<template>
  <!-- eslint-disable -->
  <div class="legal-page third-party-language p-t-large" data-test="page-thirdPartyLanguageIOS">
    <div class="container large t-c">
      <div class="m-t-3 m-b-0 t-l">
        <h2
          class="m-b-3 page-title font-normal t-c"
        >Luminary® free and open-source licensing notices for the Luminary iOS app</h2>
        <div class="m-b-2">
          <p class="m-0">Last Updated: April 23, 2019</p>
        </div>
        <div class="m-b-2 table-index">
          <p class="m-0 font-bold">TABLE OF CONTENTS</p>
          <ol>
            <li>
              <a v-scroll-to="'#documentoverview'" color="primary" href="#">Document Overview</a>
            </li>
            <li>
              <a v-scroll-to="'#osspackages'" color="primary" href="#">OSS Package Notices</a>
            </li>
            <li>
              <a v-scroll-to="'#standardosslicenses'" color="primary" href="#">Standard OSS Licenses</a>
            </li>
          </ol>
        </div>
        <div class="table-content">
          <a id="documentoverview">
            <h4>1. Document Overview</h4>
            <p>
              This document includes licensing information relating to free, open-source,
              and public-source software (together, the “SOFTWARE”) included with or used
              while developing Luminary’s iOS mobile application. The terms of the
              applicable free, open-source, and public-source licenses (each an “OSS
              LICENSE”) govern Luminary’s distribution and your use of the SOFTWARE.
              Luminary and the third-party authors, licensors, and distributors of the
              SOFTWARE disclaim all warranties and liability arising from all use and
              distribution of the SOFTWARE. To the extent the OSS is provided under an
              agreement with Luminary that differs from the applicable OSS LICENSE, those
              terms are offered by Luminary alone.
            </p>
            <p>
              Luminary has reproduced below copyright and other licensing notices
              appearing within the SOFTWARE. While Luminary seeks to provide complete and
              accurate copyright and licensing information for each SOFTWARE package,
              Luminary does not represent or warrant that the following information is
              complete, correct, or error-free. SOFTWARE recipients are encouraged to (a)
              investigate the identified SOFTWARE packages to confirm the accuracy of the
              licensing information provided herein and (b) notify Luminary of any
              inaccuracies or errors found in this document so that Luminary may update
              this document accordingly.
            </p>
            <p>
              Certain OSS LICENSES (such as the GNU General Public Licenses, GNU
              Library/Lesser General Public Licenses, Affero General Public Licenses,
              Mozilla Public Licenses, Common Development and Distribution Licenses,
              Common Public License, and Eclipse Public License) require that the source
              code corresponding to distributed OSS binaries be made available to
              recipients or other requestors under the terms of the same OSS LICENSE.
              Recipients or requestors who would like to receive a copy of such
              corresponding source code should submit a request to Luminary by post at:
            </p>
            <p>Luminary</p>
            <p>Attn: Open Source Requests</p>
            <p>250 Park Avenue South, Suite 203</p>
            <p>New York, NY 10003</p>
            <p>Please provide the following information in all submitted OSS requests:</p>
            <ul>
              <li>the OSS packages for which you are requesting source code;</li>
              <li>
                the Luminary product (and any available version information) with which
                the requested OSS packages are distributed;
              </li>
              <li>
                an email address at which Luminary may contact you regarding the
                request (if available); and
              </li>
              <li>the postal address for delivery of the requested source code.</li>
            </ul>
          </a>
          <a id="osspackages">
            <h4>2. OSS Package Notices</h4>
            <p>
              <strong>BadgeSwift</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://github.com/evgenyneu/swift-badge"
              >https://github.com/evgenyneu/swift-badge</a>
            </p>
            <p>Package licensing notices:</p>
            <p>LICENSE/</p>
            <p>The MIT License</p>
            <p>Copyright (c) 2015 Evgenii Neumerzhitckii</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>Branch Metrics iOS SDK (ios-branch-deep-linking)</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://github.com/BranchMetrics/ios-branch-deep-linking"
              >https://github.com/BranchMetrics/ios-branch-deep-linking</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/LICENSE.txt:</p>
            <p>The MIT License (MIT)</p>
            <p>Copyright (c) 2015 Branch Metrics, Inc.</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>CalmParamtericAnimations</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://github.com/calm/CalmParametricAnimations"
              >https://github.com/calm/CalmParametricAnimations</a>
              ;
            </p>
            <p>
              <a href="http://www.easings.net/">http://www.easings.net/</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/LICENSE:</p>
            <p>The MIT License (MIT)</p>
            <p>Copyright (c) 2016, Calm.com, Inc.</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>Firebase Javascript SDK</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://firebase.google.com/"
              >https://firebase.google.com/</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/LICENSE:</p>
            <p>/firebase-js-sdk/packages/auth/LICENSE:</p>
            <p>
              See
              <strong>Apache-2.0</strong>in the
              <strong>Standard OSS License Text</strong> appendix to this document.
            </p>
            <p>/tools/gitHooks/license.js:</p>
            <p>* @license</p>
            <p>* Copyright 2019 Google Inc.</p>
            <p>*</p>
            <p>* Licensed under the Apache License, Version 2.0 (the "License");</p>
            <p>* you may not use this file except in compliance with the License.</p>
            <p>* You may obtain a copy of the License at</p>
            <p>*</p>
            <p>* http://www.apache.org/licenses/LICENSE-2.0</p>
            <p>*</p>
            <p>* Unless required by applicable law or agreed to in writing, software</p>
            <p>* distributed under the License is distributed on an "AS IS" BASIS,</p>
            <p>* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.</p>
            <p>* See the License for the specific language governing permissions and</p>
            <p>* limitations under the License.</p>
            <p>*/</p>
            <p>
              <strong>Instabug</strong>
            </p>
            <p>
              Package homepage/download site:
              <a href="https://instabug.com/">https://instabug.com/</a>;
              <a
                href="https://github.com/Instabug/Instabug-iOS"
              >https://github.com/Instabug/Instabug-iOS</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/LICENSE.md:</p>
            <p>
              Copyright (C) 2014 Instabug Permission is hereby granted to use this
              framework as is, modification are not allowed.
            </p>
            <p>All rights reserved.</p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>KTCenterFlowLayout</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://github.com/keighl/KTCenterFlowLayout/"
              >https://github.com/keighl/KTCenterFlowLayout/</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/LICENSE:</p>
            <p>Copyright (c) keighl (http://github.com/keighl)</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>lottie-ios</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="http://airbnb.io/lottie/"
              >http://airbnb.io/lottie/</a>;
              <a href="https://github.com/airbnb/lottie-ios">https://github.com/airbnb/lottie-ios</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/LICENSE:</p>
            <p>
              See
              <strong>Apache-2.0</strong>in the
              <strong>Standard OSS License Text</strong> appendix to this document.
            </p>
            <p>
              <strong>New Relic Go Agent</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://github.com/newrelic/go-agent"
              >https://github.com/newrelic/go-agent</a>
            </p>
            <p>Package licensing notices:</p>
            <p>
              This product includes source derived from 'go' by The Go Authors,
              distributed
            </p>
            <p>under the following BSD license:</p>
            <p>
              <a
                href="https://github.com/golang/go/blob/master/LICENSE"
              >https://github.com/golang/go/blob/master/LICENSE</a>
            </p>
            <p>-------------------------------------------------------------------------------</p>
            <p>
              All other components of this product are Copyright: (c) 2016-2019 New
              Relic, Inc. All rights reserved.
            </p>
            <p>
              Certain inventions disclosed in this file may be claimed within patents
              owned or patent applications filed by New Relic, Inc. or third parties.
            </p>
            <p>
              Subject to the terms of this notice, New Relic grants you a nonexclusive,
              nontransferable license, without the right to sublicense, to (a) install
              and execute one copy of these files on any number of workstations owned or
              controlled by you and (b) distribute verbatim copies of these files to
              third parties. These files and their contents shall not be used in
              conjunction with any other product or software that may compete with any
              New Relic product, feature, or software or be used for the purpose of
              research, reverse engineering or developing such competitive products,
              features, or software. As a condition to the foregoing grant, you must
              provide this notice along with each copy you distribute and you must not
              remove, alter, or obscure this notice. In the event you submit or provide
              any feedback, code, pull requests, or suggestions to New Relic you hereby
              grant New Relic a worldwide, non-exclusive, irrevocable, transferrable,
              fully paid-up license to use the code, algorithms, patents, and ideas
              therein in our products.
            </p>
            <p>
              All other use, reproduction, modification, distribution, or other
              exploitation of these files is strictly prohibited, except as may be set
              forth in a separate written license agreement between you and New Relic.
              The terms of any such license agreement will control over this notice. The
              license stated above will be automatically terminated and revoked if you
              exceed its scope or violate any of the terms of this notice.
            </p>
            <p>
              This License does not grant permission to use the trade names, trademarks,
              service marks, or product names of New Relic, except as required for
              reasonable and customary use in describing the origin of this file and
              reproducing the content of this notice. You may not mark or brand this file
              with any trade name, trademarks, service marks, or product names other than
              the original brand (if any) provided by New Relic.
            </p>
            <p>
              Unless otherwise expressly agreed by New Relic in a separate written
              license agreement, these files are provided AS IS, WITHOUT WARRANTY OF ANY
              KIND, including without any implied warranties of MERCHANTABILITY, FITNESS
              FOR A PARTICULAR PURPOSE, TITLE, or NON-INFRINGEMENT. As a condition to
              your use of these files, you are solely responsible for such use. New Relic
              will have no liability to you for direct, indirect, consequential,
              incidental, special, or punitive damages or for lost profits or data.
            </p>
            <p>/LICENSE:</p>
            <p>Copyright (c) 2009 The Go Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              <strong>NVActivityIndicatorView</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://github.com/ninjaprox/NVActivityIndicatorView"
              >https://github.com/ninjaprox/NVActivityIndicatorView</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/README.md:</p>
            <p>License</p>
            <p>The MIT License (MIT)</p>
            <p>
              Copyright (c) 2016 Vinh Nguyen
              <a href="http://twitter.com/ninjaprox">@ninjaprox</a>
            </p>
            <p>/LICENSE:</p>
            <p>The MIT License (MIT)</p>
            <p>Copyright (c) 2016 Vinh Nguyen</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>Reachability.swift</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://github.com/ashleymills/Reachability.swift/"
              >https://github.com/ashleymills/Reachability.swift/</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/LICENSE:</p>
            <p>Copyright (c) 2016 Ashley Mills</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>SDWebImage</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://sdwebimage.github.io/"
              >https://sdwebimage.github.io/</a>;
            </p>
            <p>
              <a
                href="https://github.com/SDWebImage/SDWebImage/"
              >https://github.com/SDWebImage/SDWebImage/</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/README.md:</p>
            <p>
              <strong>Licenses</strong>
            </p>
            <p>
              All source code is licensed under the
              <a
                href="https://raw.github.com/SDWebImage/SDWebImage/master/LICENSE"
              >MIT License</a>
              .
            </p>
            <p>/LICENSE:</p>
            <p>Copyright (c) 2009-2017 Olivier Poitrey rs@dailymotion.com</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>Segment IO Analytics for iOS</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://segment.com/libraries/ios"
              >https://segment.com/libraries/ios</a>
            </p>
            <p>
              <a
                href="https://github.com/segmentio/analytics-ios"
              >https://github.com/segmentio/analytics-ios</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/LICENSE:</p>
            <p>The MIT License (MIT)</p>
            <p>Copyright (c) 2016 Segment.io, Inc.</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>Sentry SDK for iOS/macOS/tvOS/watchOS (sentry-cocoa)</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://sentry.io/for/cocoa/"
              >https://sentry.io/for/cocoa/</a>;
              <a
                href="https://github.com/getsentry/sentry-cocoa"
              >https://github.com/getsentry/sentry-cocoa</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/LICENSE.md:</p>
            <p>The MIT License (MIT)</p>
            <p>Copyright (c) 2015 Sentry</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>SkeletonView</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://github.com/Juanpe/SkeletonView"
              >https://github.com/Juanpe/SkeletonView</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/README.md:</p>
            <p>/LICENSE:</p>
            <p>MIT License</p>
            <p>Copyright (c) 2017 Juanpe Catalán</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              <strong>SwaggerCodegen</strong>
            </p>
            <p>
              Package homepage/download site:
              <a href="http://swagger.io/">http://swagger.io/</a>;
            </p>
            <p>
              <a
                href="https://github.com/swagger-api/swagger-codegen"
              >https://github.com/swagger-api/swagger-codegen</a>
            </p>
            <p>/README.md:</p>
            <p>
              <strong>License information on Generated Code</strong>
            </p>
            <p>
              The Swagger Codegen project is intended as a benefit for users of the
              Swagger / Open API Specification. The project itself has the
              <a
                href="https://github.com/swagger-api/swagger-codegen#license"
              >License</a>
              as specified. In addition, please understand the following points:
            </p>
            <ul>
              <li>
                The templates included with this project are subject to the
                <a
                  href="https://github.com/swagger-api/swagger-codegen#license"
                >License</a>
                .
              </li>
              <li>
                Generated code is intentionally
                <em>not</em> subject to the parent
                project license
              </li>
            </ul>
            <p>
              When code is generated from this project, it shall be considered
              <strong>AS IS</strong> and owned by the user of the software. There are no
              warranties--expressed or implied--for generated code. You can do what you
              wish with it, and once generated, the code is your responsibility and
              subject to the licensing terms that you deem appropriate.
            </p>
            <p>
              <strong>License</strong>
            </p>
            <p>Copyright 2018 SmartBear Software</p>
            <p>
              Licensed under the Apache License, Version 2.0 (the "License"); you may not
              use this file except in compliance with the License. You may obtain a copy
              of the License at
              <a
                href="http://www.apache.org/licenses/LICENSE-2.0"
              >apache.org/licenses/LICENSE-2.0</a>
            </p>
            <p>
              Unless required by applicable law or agreed to in writing, software
              distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
              WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
              License for the specific language governing permissions and limitations
              under the License.
            </p>
            <p>/LICENSE:</p>
            <p>Copyright 2016 SmartBear Software</p>
            <p>
              Licensed under the Apache License, Version 2.0 (the "License"); you may not
              use this file except in compliance with the License. You may obtain a copy
              of the License at
            </p>
            <p>[apache.org/licenses/LICENSE-2.0](http://www.apache.org/licenses/LICENSE-2.0)</p>
            <p>
              Unless required by applicable law or agreed to in writing, software
              distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
              WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
              License for the specific language governing permissions and limitations
              under the License.
            </p>
            <p>
              See
              <strong>Apache-2.0</strong>in the
              <strong>Standard OSS License Text</strong> appendix to this document.
            </p>
            <p>/modules/swagger-codegen/src/main/resources/_common/LICENSE:</p>
            <p>/modules/swagger-codegen/src/test/resources/integrationtests/typescript/additional-properties-expected/LICENSE:</p>
            <p>/modules/swagger-codegen/src/test/resources/integrationtests/typescript/array-and-object-expected/LICENSE:</p>
            <p>/modules/swagger-codegen/src/test/resources/integrationtests/typescript/node-es5-expected/LICENSE:</p>
            <p>/modules/swagger-codegen/src/test/resources/integrationtests/typescript/petstore-expected/LICENSE:</p>
            <p>/samples/client/petstore-security-test/go/LICENSE:</p>
            <p>/samples/client/petstore-security-test/javascript-closure-angular/LICENSE:</p>
            <p>/samples/client/petstore-security-test/javascript/LICENSE:</p>
            <p>/samples/client/petstore-security-test/objc/LICENSE:</p>
            <p>/samples/client/petstore-security-test/perl/LICENSE:</p>
            <p>/samples/client/petstore-security-test/perl/deep_module_test/LICENSE:</p>
            <p>/samples/client/petstore-security-test/php/LICENSE:</p>
            <p>/samples/client/petstore-security-test/php/SwaggerClient-php/LICENSE:</p>
            <p>/samples/client/petstore-security-test/python/LICENSE:</p>
            <p>/samples/client/petstore-security-test/qt5cpp/LICENSE:</p>
            <p>/samples/client/petstore-security-test/ruby/LICENSE:</p>
            <p>/samples/client/petstore-security-test/scala/LICENSE:</p>
            <p>/samples/client/petstore-security-test/swift/LICENSE:</p>
            <p>/samples/client/petstore-security-test/typescript-angular2/LICENSE:</p>
            <p>/samples/client/petstore-security-test/typescript-node/LICENSE:</p>
            <p>/samples/server/petstore-security-test/lumen/LICENSE:</p>
            <p>/samples/server/petstore-security-test/silex/LICENSE:</p>
            <p>/samples/server/petstore-security-test/slim/LICENSE:</p>
            <p>
              See
              <strong>Apache-2.0</strong>in the
              <strong>Standard OSS License Text</strong> appendix to this document.
            </p>
            <p>/samples/server/petstore-security-test/slim/vendor/composer/LICENSE:</p>
            <p>Copyright (c) 2016 Nils Adermann, Jordi Boggiano</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/server/petstore-security-test/slim/vendor/container-interop/container-interop/LICENSE:</p>
            <p>The MIT License (MIT)</p>
            <p>Copyright (c) 2013 container-interop</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/server/petstore-security-test/slim/vendor/nikic/fast-route/LICENSE:</p>
            <p>Copyright (c) 2013 by Nikita Popov.</p>
            <p>Some rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are
            </p>
            <p>met:</p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * The names of the contributors may not be used to endorse or promote
              products derived from this software without specific prior written
              permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>/samples/server/petstore-security-test/slim/vendor/pimple/pimple/LICENSE:</p>
            <p>Copyright (c) 2009-2015 Fabien Potencier</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/server/petstore-security-test/slim/vendor/psr/http-message/LICENSE:</p>
            <p>Copyright (c) 2014 PHP Framework Interoperability Group</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/server/petstore/java-play-framework-api-package-override/LICENSE:</p>
            <p>/samples/server/petstore/java-play-framework-async/LICENSE:</p>
            <p>/samples/server/petstore/java-play-framework-controller-only/LICENSE:</p>
            <p>/samples/server/petstore/java-play-framework-fake-endpoints/LICENSE:</p>
            <p>/samples/server/petstore/java-play-framework-no-bean-validation/LICENSE:</p>
            <p>/samples/server/petstore/java-play-framework-no-exception-handling/LICENSE:</p>
            <p>/samples/server/petstore/java-play-framework-no-interface/LICENSE:</p>
            <p>/samples/server/petstore/java-play-framework-no-swagger-ui/LICENSE:</p>
            <p>/samples/server/petstore/java-play-framework-no-wrap-calls/LICENSE:</p>
            <p>/samples/server/petstore/java-play-framework/LICENSE:</p>
            <p>This software is licensed under the Apache 2 license, quoted below.</p>
            <p>
              Licensed under the Apache License, Version 2.0 (the "License"); you may not
              use this project except in compliance with the License. You may obtain a
              copy of the License at
              <a
                href="http://www.apache.org/licenses/LICENSE-2.0"
              >http://www.apache.org/licenses/LICENSE-2.0</a>
              .
            </p>
            <p>
              Unless required by applicable law or agreed to in writing, software
              distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
              WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
              License for the specific language governing permissions and limitations
              under the License.
            </p>
            <p>
              See
              <strong>Apache-2.0</strong>in the
              <strong>Standard OSS License Text</strong> appendix to this document.
            </p>
            <p>/samples/client/petstore/swift3/default/SwaggerClientTests/Pods/Alamofire/LICENSE:</p>
            <p>
              Copyright (c) 2014-2016 Alamofire Software Foundation
              (http://alamofire.org/)
            </p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/client/petstore/swift3/promisekit/SwaggerClientTests/Pods/Alamofire/LICENSE:</p>
            <p>
              Copyright (c) 2014-2016 Alamofire Software Foundation
              (http://alamofire.org/)
            </p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/client/petstore/swift3/rxswift/SwaggerClientTests/Pods/Alamofire/LICENSE:</p>
            <p>
              Copyright (c) 2014-2016 Alamofire Software Foundation
              (http://alamofire.org/)
            </p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/client/petstore/swift4/default/SwaggerClientTests/Pods/Alamofire/LICENSE:</p>
            <p>
              Copyright (c) 2014-2016 Alamofire Software Foundation
              (http://alamofire.org/)
            </p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/client/petstore/swift4/promisekit/SwaggerClientTests/Pods/Alamofire/LICENSE:</p>
            <p>
              Copyright (c) 2014-2016 Alamofire Software Foundation
              (http://alamofire.org/)
            </p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/client/petstore/swift3/promisekit/SwaggerClientTests/Pods/PromiseKit/LICENSE:</p>
            <p>Copyright 2016, Max Howell; mxcl@me.com</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/client/petstore/swift4/rxswift/SwaggerClientTests/Pods/Alamofire/LICENSE:</p>
            <p>/samples/client/test/swift4/default/TestClientApp/Pods/Alamofire/LICENSE:</p>
            <p>
              Copyright (c) 2014-2017 Alamofire Software Foundation
              (http://alamofire.org/)
            </p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/client/petstore/dart-jaguar/flutter_petstore/ios/Flutter/flutter_assets/LICENSE:</p>
            <p>analyzer</p>
            <p>args</p>
            <p>csslib</p>
            <p>logging</p>
            <p>Copyright 2013, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>async</p>
            <p>collection</p>
            <p>convert</p>
            <p>crypto</p>
            <p>mime</p>
            <p>package_config</p>
            <p>package_resolver</p>
            <p>plugin</p>
            <p>shelf_static</p>
            <p>source_map_stack_trace</p>
            <p>stream_channel</p>
            <p>typed_data</p>
            <p>utf</p>
            <p>vm_service_client</p>
            <p>Copyright 2015, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided
            </p>
            <p>with the distribution.</p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>auth_header</p>
            <p>Copyright (c) 2016, Ravi Teja Gudapati.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of the &lt;organization&gt; nor the names of its
              contributors may be used to endorse or promote products derived from this
              software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL &lt;COPYRIGHT HOLDER&gt; BE LIABLE FOR
              ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
              DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
              LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
              OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boolean_selector</p>
            <p>front_end</p>
            <p>kernel</p>
            <p>meta</p>
            <p>shelf_packages_handler</p>
            <p>web_socket_channel</p>
            <p>Copyright 2016, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (C) 1995-1997 Eric Young (eay@cryptsoft.com)</p>
            <p>All rights reserved.</p>
            <p>
              This package is an SSL implementation written by Eric Young
              (eay@cryptsoft.com).
            </p>
            <p>The implementation was written so as to conform with Netscapes SSL.</p>
            <p>
              This library is free for commercial and non-commercial use as long as the
              following conditions are aheared to. The following conditions apply to all
              code found in this distribution, be it the RC4, RSA, lhash, DES, etc.,
              code; not just the SSL code. The SSL documentation included with this
              distribution is covered by the same copyright terms except that the holder
              is Tim Hudson (tjh@cryptsoft.com).
            </p>
            <p>
              Copyright remains Eric Young's, and as such any Copyright notices in the
              code are not to be removed.
            </p>
            <p>
              If this package is used in a product, Eric Young should be given
              attribution as the author of the parts of the library used.
            </p>
            <p>
              This can be in the form of a textual message at program startup or in
              documentation (online or textual) provided with the package.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the copyright notice, this
              list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgement:
            </p>
            <p>
              "This product includes cryptographic software written by Eric Young
              (eay@cryptsoft.com)"
            </p>
            <p>
              The word 'cryptographic' can be left out if the rouines from the library
              being used are not cryptographic related :-).
            </p>
            <p>
              4. If you include any Windows specific code (or a derivative thereof) from
              the apps directory (application code) you must include an acknowledgement:
            </p>
            <p>"This product includes software written by Tim Hudson (tjh@cryptsoft.com)"</p>
            <p>
              THIS SOFTWARE IS PROVIDED BY ERIC YOUNG ``AS IS'' AND ANY EXPRESS OR
              IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES
              OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN
              NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
              INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
              LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
              OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.
            </p>
            <p>
              The licence and distribution terms for any publically available version or
              derivative of this code cannot be changed. i.e. this code cannot simply be
              copied and put under another distribution licence [including the GNU Public
              Licence.]
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (C) 1995-1998 Eric Young (eay@cryptsoft.com)</p>
            <p>All rights reserved.</p>
            <p>
              This package is an SSL implementation written by Eric Young
              (eay@cryptsoft.com).
            </p>
            <p>The implementation was written so as to conform with Netscapes SSL.</p>
            <p>
              This library is free for commercial and non-commercial use as long as the
              following conditions are aheared to. The following conditions apply to all
              code found in this distribution, be it the RC4, RSA, lhash, DES, etc.,
              code; not just the SSL code. The SSL documentation included with this
              distribution is covered by the same copyright terms except that the holder
              is Tim Hudson (tjh@cryptsoft.com).
            </p>
            <p>
              Copyright remains Eric Young's, and as such any Copyright notices in the
              code are not to be removed.
            </p>
            <p>
              If this package is used in a product, Eric Young should be given
              attribution as the author of the parts of the library used.
            </p>
            <p>
              This can be in the form of a textual message at program startup or in
              documentation (online or textual) provided with the package.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the copyright notice, this
              list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgement:
            </p>
            <p>
              "This product includes cryptographic software written by Eric Young
              (eay@cryptsoft.com)"
            </p>
            <p>
              The word 'cryptographic' can be left out if the rouines from the library
              being used are not cryptographic related :-).
            </p>
            <p>
              4. If you include any Windows specific code (or a derivative thereof) from
              the apps directory (application code) you must include an acknowledgement:
            </p>
            <p>"This product includes software written by Tim Hudson (tjh@cryptsoft.com)"</p>
            <p>
              THIS SOFTWARE IS PROVIDED BY ERIC YOUNG ``AS IS'' AND ANY EXPRESS OR
              IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES
              OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN
              NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
              INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
              LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
              OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.
            </p>
            <p>
              The licence and distribution terms for any publically available version or
              derivative of this code cannot be changed. i.e. this code cannot simply be
              copied and put under another distribution licence [including the GNU Public
              Licence.]
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1998-2000 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1998-2001 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1998-2002 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1998-2003 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1998-2004 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1998-2005 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1998-2005 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1998-2006 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1998-2007 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1998-2011 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1999 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1999-2002 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1999-2003 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1999-2004 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1999-2005 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1999-2007 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 1999-2008 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2000 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2000-2002 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2000-2003 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2000-2005 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2001 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2001-2011 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2002-2006 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2003 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2004 Kungliga Tekniska Högskolan</p>
            <p>(Royal Institute of Technology, Stockholm, Sweden).</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. Neither the name of the Institute nor the names of its contributors may
              be used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE INSTITUTE AND CONTRIBUTORS ``AS IS'' AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE INSTITUTE OR CONTRIBUTORS BE LIABLE
              FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
              DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
              LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
              OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2004 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2005 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2006 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2006,2007 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2008 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2010 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2011 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2011 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2012 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2013 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2014 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the copyright notice, this
              list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgement:
            </p>
            <p>
              "This product includes cryptographic software written by Eric Young
              (eay@cryptsoft.com)"
            </p>
            <p>
              The word 'cryptographic' can be left out if the rouines from the library
              being used are not cryptographic related :-).
            </p>
            <p>
              4. If you include any Windows specific code (or a derivative thereof) from
              the apps directory (application code) you must include an acknowledgement:
            </p>
            <p>"This product includes software written by Tim Hudson (tjh@cryptsoft.com)"</p>
            <p>
              THIS SOFTWARE IS PROVIDED BY ERIC YOUNG ``AS IS'' AND ANY EXPRESS OR
              IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES
              OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN
              NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
              INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
              LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
              OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.
            </p>
            <p>
              The licence and distribution terms for any publically available version or
              derivative of this code cannot be changed. i.e. this code cannot simply be
              copied and put under another distribution licence [including the GNU Public
              Licence.]
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2014, Google Inc.</p>
            <p>
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted, provided that the above
              copyright notice and this permission notice appear in all copies.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
              WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
              SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
              WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
              IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2015 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2015, Google Inc.</p>
            <p>
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted, provided that the above
              copyright notice and this permission notice appear in all copies.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
              WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
              SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
              WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
              IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2015, Intel Inc.</p>
            <p>
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted, provided that the above
              copyright notice and this permission notice appear in all copies.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
              WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
              SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
              WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
              IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2015-2016 the fiat-crypto authors (see the AUTHORS file).</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2016, Google Inc.</p>
            <p>
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted, provided that the above
              copyright notice and this permission notice appear in all copies.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
              WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
              SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
              WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
              IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2017, Google Inc.</p>
            <p>
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted, provided that the above
              copyright notice and this permission notice appear in all copies.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
              WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
              SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
              WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
              IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright (c) 2018, Google Inc.</p>
            <p>
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted, provided that the above
              copyright notice and this permission notice appear in all copies.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
              WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
              SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
              WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
              IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 1995-2016 The OpenSSL Project Authors. All Rights Reserved.</p>
            <p>
              Licensed under the OpenSSL license (the "License"). You may not use this
              file except in compliance with the License. You can obtain a copy in the
              file LICENSE in the source distribution or at
            </p>
            <p>
              <a
                href="https://www.openssl.org/source/license.html"
              >https://www.openssl.org/source/license.html</a>
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2000-2016 The OpenSSL Project Authors. All Rights Reserved.</p>
            <p>
              Licensed under the OpenSSL license (the "License"). You may not use this
              file except in compliance with the License. You can obtain a copy in the
              file LICENSE in the source distribution or at
            </p>
            <p>
              <a
                href="https://www.openssl.org/source/license.html"
              >https://www.openssl.org/source/license.html</a>
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2002 Sun Microsystems, Inc. ALL RIGHTS RESERVED.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2002 Sun Microsystems, Inc. ALL RIGHTS RESERVED.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.OpenSSL.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              licensing@OpenSSL.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.OpenSSL.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2003 Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2005 Nokia. All rights reserved.</p>
            <p>
              The portions of the attached software ("Contribution") is developed by
              Nokia Corporation and is licensed pursuant to the OpenSSL open source
              license.
            </p>
            <p>
              The Contribution, originally written by Mika Kousa and Pasi Eronen of Nokia
              Corporation, consists of the "PSK" (Pre-Shared Key) ciphersuites support
              (see RFC 4279) to OpenSSL.
            </p>
            <p>
              No patent licenses or other rights except those expressly stated in the
              OpenSSL open source license shall be deemed granted or received expressly,
              by implication, estoppel, or otherwise.
            </p>
            <p>
              No assurances are provided by Nokia that the Contribution does not infringe
              the patent or other intellectual property rights of any third party or that
              the license provides you with all the necessary rights to make use of the
              Contribution.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. IN ADDITION
              TO THE DISCLAIMERS INCLUDED IN THE LICENSE, NOKIA SPECIFICALLY DISCLAIMS
              ANY LIABILITY FOR CLAIMS BROUGHT BY YOU OR ANY OTHER ENTITY BASED ON
              INFRINGEMENT OF INTELLECTUAL PROPERTY RIGHTS OR OTHERWISE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2005, Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2006, Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2006-2017 The OpenSSL Project Authors. All Rights Reserved.</p>
            <p>Licensed under the OpenSSL license (the "License"). You may not use</p>
            <p>this file except in compliance with the License. You can obtain a copy</p>
            <p>in the file LICENSE in the source distribution or at</p>
            <p>https://www.openssl.org/source/license.html</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2007, Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2007-2016 The OpenSSL Project Authors. All Rights Reserved.</p>
            <p>
              Licensed under the OpenSSL license (the "License"). You may not use this
              file except in compliance with the License. You can obtain a copy in the
              file LICENSE in the source distribution or at
            </p>
            <p>
              <a
                href="https://www.openssl.org/source/license.html"
              >https://www.openssl.org/source/license.html</a>
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2008 Google Inc.</p>
            <p>All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2008, Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2009 Google Inc.</p>
            <p>All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2009 Google Inc. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2009, Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2012-2016 The OpenSSL Project Authors. All Rights Reserved.</p>
            <p>
              Licensed under the OpenSSL license (the "License"). You may not use this
              file except in compliance with the License. You can obtain a copy in the
              file LICENSE in the source distribution or at
            </p>
            <p>
              <a
                href="https://www.openssl.org/source/license.html"
              >https://www.openssl.org/source/license.html</a>
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2013-2016 The OpenSSL Project Authors. All Rights Reserved.</p>
            <p>Copyright (c) 2012, Intel Corporation. All Rights Reserved.</p>
            <p>
              Licensed under the OpenSSL license (the "License"). You may not use this
              file except in compliance with the License. You can obtain a copy in the
              file LICENSE in the source distribution or at
            </p>
            <p>
              <a
                href="https://www.openssl.org/source/license.html"
              >https://www.openssl.org/source/license.html</a>
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2014-2016 The OpenSSL Project Authors. All Rights Reserved.</p>
            <p>
              Licensed under the OpenSSL license (the "License"). You may not use this
              file except in compliance with the License. You can obtain a copy in the
              file LICENSE in the source distribution or at
            </p>
            <p>
              <a
                href="https://www.openssl.org/source/license.html"
              >https://www.openssl.org/source/license.html</a>
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2014-2016 The OpenSSL Project Authors. All Rights Reserved.</p>
            <p>Copyright (c) 2014, Intel Corporation. All Rights Reserved.</p>
            <p>
              Licensed under the OpenSSL license (the "License"). You may not use this
              file except in compliance with the License. You can obtain a copy in the
              file LICENSE in the source distribution or at
            </p>
            <p>
              <a
                href="https://www.openssl.org/source/license.html"
              >https://www.openssl.org/source/license.html</a>
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2015, Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2015-2016 The OpenSSL Project Authors. All Rights Reserved.</p>
            <p>
              Licensed under the OpenSSL license (the "License"). You may not use this
              file except in compliance with the License. You can obtain a copy in the
              file LICENSE in the source distribution or at
            </p>
            <p>
              <a
                href="https://www.openssl.org/source/license.html"
              >https://www.openssl.org/source/license.html</a>
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>Copyright 2016 Brian Smith.</p>
            <p>
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted, provided that the above
              copyright notice and this permission notice appear in all copies.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
              WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
              SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
              WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
              IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>The MIT License (MIT)</p>
            <p>
              Copyright (c) 2015-2016 the fiat-crypto authors (see
              <a
                href="https://github.com/mit-plv/fiat-crypto/blob/master/AUTHORS"
              >https://github.com/mit-plv/fiat-crypto/blob/master/AUTHORS</a>
              ).
            </p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>dart</p>
            <p>OpenSSL License</p>
            <p>====================================================================</p>
            <p>Copyright (c) 1998-2011 The OpenSSL Project. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. All advertising materials mentioning features or use of this software
              must display the following acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit. (http://www.openssl.org/)"
            </p>
            <p>
              4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be used to
              endorse or promote products derived from this software without prior
              written permission. For written permission, please contact
              openssl-core@openssl.org.
            </p>
            <p>
              5. Products derived from this software may not be called "OpenSSL" nor may
              "OpenSSL" appear in their names without prior written permission of the
              OpenSSL Project.
            </p>
            <p>
              6. Redistributions of any form whatsoever must retain the following
              acknowledgment:
            </p>
            <p>
              "This product includes software developed by the OpenSSL Project for use in
              the OpenSSL Toolkit (http://www.openssl.org/)"
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY
              EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>====================================================================</p>
            <p>
              This product includes cryptographic software written by Eric Young
              (eay@cryptsoft.com). This product includes software written by Tim Hudson
              (tjh@cryptsoft.com).
            </p>
            <p>Original SSLeay License</p>
            <p>* Copyright (C) 1995-1998 Eric Young (eay@cryptsoft.com)</p>
            <p>* All rights reserved.</p>
            <p>* This package is an SSL implementation written</p>
            <p>* by Eric Young (eay@cryptsoft.com).</p>
            <p>* The implementation was written so as to conform with Netscapes SSL.</p>
            <p>* This library is free for commercial and non-commercial use as long as</p>
            <p>* the following conditions are aheared to. The following conditions</p>
            <p>* apply to all code found in this distribution, be it the RC4, RSA,</p>
            <p>* lhash, DES, etc., code; not just the SSL code. The SSL documentation</p>
            <p>* included with this distribution is covered by the same copyright terms</p>
            <p>* except that the holder is Tim Hudson (tjh@cryptsoft.com).</p>
            <p>* Copyright remains Eric Young's, and as such any Copyright notices in</p>
            <p>* the code are not to be removed.</p>
            <p>
              * If this package is used in a product, Eric Young should be given
              attribution
            </p>
            <p>* as the author of the parts of the library used.</p>
            <p>* This can be in the form of a textual message at program startup or</p>
            <p>* in documentation (online or textual) provided with the package.</p>
            <p>* Redistribution and use in source and binary forms, with or without</p>
            <p>* modification, are permitted provided that the following conditions</p>
            <p>* are met:</p>
            <p>* 1. Redistributions of source code must retain the copyright</p>
            <p>* notice, this list of conditions and the following disclaimer.</p>
            <p>* 2. Redistributions in binary form must reproduce the above copyright</p>
            <p>* notice, this list of conditions and the following disclaimer in the</p>
            <p>* documentation and/or other materials provided with the distribution.</p>
            <p>* 3. All advertising materials mentioning features or use of this software</p>
            <p>* must display the following acknowledgement:</p>
            <p>* "This product includes cryptographic software written by</p>
            <p>* Eric Young (eay@cryptsoft.com)"</p>
            <p>* The word 'cryptographic' can be left out if the rouines from the library</p>
            <p>* being used are not cryptographic related :-).</p>
            <p>
              * 4. If you include any Windows specific code (or a derivative thereof)
              from
            </p>
            <p>
              * the apps directory (application code) you must include an
              acknowledgement:
            </p>
            <p>
              * "This product includes software written by Tim Hudson
              (tjh@cryptsoft.com)"
            </p>
            <p>* THIS SOFTWARE IS PROVIDED BY ERIC YOUNG ``AS IS'' AND</p>
            <p>* ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE</p>
            <p>
              * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE
            </p>
            <p>* ARE DISCLAIMED. IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE</p>
            <p>
              * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL
            </p>
            <p>* DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS</p>
            <p>* OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)</p>
            <p>
              * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
              STRICT
            </p>
            <p>* LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY</p>
            <p>* OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF</p>
            <p>* SUCH DAMAGE.</p>
            <p>
              * The licence and distribution terms for any publically available version
              or
            </p>
            <p>
              * derivative of this code cannot be changed. i.e. this code cannot simply
              be
            </p>
            <p>* copied and put under another distribution licence</p>
            <p>* [including the GNU Public Licence.]</p>
            <p>ISC license used for completely new code in BoringSSL:</p>
            <p>/* Copyright (c) 2015, Google Inc.</p>
            <p>* Permission to use, copy, modify, and/or distribute this software for any</p>
            <p>* purpose with or without fee is hereby granted, provided that the above</p>
            <p>* copyright notice and this permission notice appear in all copies.</p>
            <p>* THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES</p>
            <p>* WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF</p>
            <p>
              * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
              ANY
            </p>
            <p>* SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES</p>
            <p>
              * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION
            </p>
            <p>* OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN</p>
            <p>* CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.</p>
            <p>The code in third_party/fiat carries the MIT license:</p>
            <p>Copyright (c) 2015-2016 the fiat-crypto authors (see</p>
            <p>https://github.com/mit-plv/fiat-crypto/blob/master/AUTHORS).</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>Licenses for support code</p>
            <p>
              Parts of the TLS test suite are under the Go license. This code is not
              included in BoringSSL (i.e. libcrypto and libssl) when compiled, however,
              so distributing code linked against BoringSSL does not trigger this
              license:
            </p>
            <p>Copyright (c) 2009 The Go Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>boringssl</p>
            <p>observatory_pub_packages</p>
            <p>skia</p>
            <p>txt</p>
            <p>vulkan</p>
            <p>Apache License</p>
            <p>Version 2.0, January 2004</p>
            <p>http://www.apache.org/licenses</p>
            <p>
              See
              <strong>Apache-2.0</strong> in the
              <strong>Standard OSS License Text</strong> appendix to this document.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>charcode</p>
            <p>glob</p>
            <p>http</p>
            <p>http_multi_server</p>
            <p>http_parser</p>
            <p>json_rpc_2</p>
            <p>matcher</p>
            <p>path</p>
            <p>pool</p>
            <p>pub_semver</p>
            <p>shelf</p>
            <p>shelf_web_socket</p>
            <p>source_maps</p>
            <p>source_span</p>
            <p>stack_trace</p>
            <p>string_scanner</p>
            <p>test</p>
            <p>watcher</p>
            <p>yaml</p>
            <p>Copyright 2014, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>client_cookie</p>
            <p>Copyright (c) 2017, teja.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of the &lt;organization&gt; nor the names of its
              contributors may be used to endorse or promote products derived from this
              software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL &lt;COPYRIGHT HOLDER&gt; BE LIABLE FOR
              ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
              DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
              LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
              OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>colorama</p>
            <p>Copyright (c) 2010 Jonathan Hartley</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of the copyright holders, nor those of its contributors
              may be used to endorse or promote products derived from this software
              without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>cupertino_icons</p>
            <p>The MIT License (MIT)</p>
            <p>Copyright (c) 2016 Drifty (http://drifty.com/)</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>Copyright (c) 2003-2005 Tom Wu</p>
            <p>Copyright (c) 2012 Adam Singer (adam@solvr.io)</p>
            <p>All Rights Reserved.</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND, EXPRESS,
              IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY WARRANTY OF
              MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. IN NO EVENT SHALL TOM
              WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT OR CONSEQUENTIAL DAMAGES
              OF ANY KIND, OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
              PROFITS, WHETHER OR NOT ADVISED OF THE POSSIBILITY OF DAMAGE, AND ON ANY
              THEORY OF LIABILITY, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
              PERFORMANCE OF THIS SOFTWARE.
            </p>
            <p>In addition, the following condition applies:</p>
            <p>
              All redistributions must retain an intact copy of this copyright notice and
              disclaimer.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>
              Copyright (c) 2011, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>
              Copyright (c) 2012, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>
              Copyright (c) 2013, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>
              Copyright (c) 2014, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>
              Copyright (c) 2015, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>
              Copyright (c) 2016, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>
              Copyright (c) 2017, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided
            </p>
            <p>with the distribution.</p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>
              Copyright (c) 2018, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>
              Copyright (c) 2018, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>Copyright 2009 The Go Authors. All rights reserved.</p>
            <p>
              Use of this source code is governed by a BSD-style license that can be
              found in the LICENSE file
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>dart</p>
            <p>Copyright 2012, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>double-conversion</p>
            <p>icu</p>
            <p>Copyright 2006-2008 the V8 project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided
            </p>
            <p>with the distribution.</p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>double-conversion</p>
            <p>icu</p>
            <p>Copyright 2010 the V8 project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>double-conversion</p>
            <p>icu</p>
            <p>Copyright 2012 the V8 project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>Copyright (c) 2013 The Chromium Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>Copyright 2017 The Flutter Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>Copyright 2018 The Flutter Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>garnet</p>
            <p>Copyright 2013 The Chromium Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>garnet</p>
            <p>icu</p>
            <p>skia</p>
            <p>topaz</p>
            <p>Copyright 2015 The Chromium Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>garnet</p>
            <p>icu</p>
            <p>topaz</p>
            <p>Copyright 2014 The Chromium Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>garnet</p>
            <p>tonic</p>
            <p>topaz</p>
            <p>Copyright 2016 The Fuchsia Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>garnet</p>
            <p>tonic</p>
            <p>topaz</p>
            <p>Copyright 2017 The Fuchsia Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>garnet</p>
            <p>topaz</p>
            <p>txt</p>
            <p>Copyright 2017 The Chromium Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>icu</p>
            <p>skia</p>
            <p>topaz</p>
            <p>Copyright 2016 The Chromium Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>engine</p>
            <p>skia</p>
            <p>topaz</p>
            <p>Copyright 2018 The Chromium Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>files</p>
            <p>Copyright (c) 1998, 1999 Thai Open Source Software Center Ltd</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>files</p>
            <p>Copyright (c) 1998, 1999, 2000 Thai Open Source Software Center Ltd</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>files</p>
            <p>
              Copyright (c) 1998, 1999, 2000 Thai Open Source Software Center Ltd and
              Clark Cooper
            </p>
            <p>Copyright (c) 2001, 2002, 2003, 2004, 2005, 2006 Expat maintainers.</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>files</p>
            <p>Copyright 2000, Clark Cooper</p>
            <p>All rights reserved.</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright (C) 1995-2002 Jean-loup Gailly and Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright (C) 1995-2002 Jean-loup Gailly.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright (C) 1995-2002 Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright (C) 2000, 2001, 2002, 2003, 2006, 2010 by</p>
            <p>Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright (C) 2000-2004, 2006-2011, 2013, 2014 by</p>
            <p>Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright (C) 2001, 2002 by Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright (C) 2001, 2002, 2003, 2004 by Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright (C) 2001-2008, 2011, 2013, 2014 by Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright 1990, 1994, 1998 The Open Group</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>
              Except as contained in this notice, the name of The Open Group shall not be
              used in advertising or otherwise to promote the sale, use or other dealings
              in this Software without prior written authorization from The Open Group.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright 2000 Computing Research Labs, New Mexico State University</p>
            <p>Copyright 2001-2004, 2011 Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright 2000 Computing Research Labs, New Mexico State University</p>
            <p>Copyright 2001-2014 Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright 2000 Computing Research Labs, New Mexico State University</p>
            <p>Copyright 2001-2015 Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright 2000, 2001, 2004 by Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright 2000-2001, 2002 by Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright 2000-2001, 2003 by Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright 2000-2010, 2012-2014 by Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright 2001, 2002, 2012 Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>Copyright 2003 by Francesco Zappa Nardelli</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>freetype2</p>
            <p>The FreeType Project LICENSE</p>
            <p>2006-Jan-27</p>
            <p>
              Copyright 1996-2002, 2006 by David Turner, Robert Wilhelm, and Werner
              Lemberg
            </p>
            <p>Introduction</p>
            <p>============</p>
            <p>Introduction</p>
            <p>
              The FreeType Project is distributed in several archive packages; some of
              them may contain, in addition to the FreeType font engine, various tools
              and contributions which rely on, or relate to, the FreeType Project.
            </p>
            <p>
              This license applies to all files found in such packages, and which do not
              fall under their own explicit license. The license affects thus the
              FreeType font engine, the test programs, documentation and makefiles, at
              the very least.
            </p>
            <p>
              This license was inspired by the BSD, Artistic, and IJG (Independent JPEG
              Group) licenses, which all encourage inclusion and use of free software in
              commercial and freeware products alike. As a consequence, its main points
              are that:
            </p>
            <p>
              o We don't promise that this software works. However, we will be interested
              in any kind of bug reports. (`as is' distribution)
            </p>
            <p>
              o You can use this software for whatever you want, in parts or full form,
              without having to pay us. (`royalty-free' usage)
            </p>
            <p>
              o You may not pretend that you wrote this software. If you use it, or only
              parts of it, in a program, you must acknowledge somewhere in your
              documentation that you have used the FreeType code. (`credits')
            </p>
            <p>
              We specifically permit and encourage the inclusion of this software, with
              or without modifications, in commercial products. We disclaim all
              warranties covering The FreeType Project and assume no liability related to
              The FreeType Project.
            </p>
            <p>
              Finally, many people asked us for a preferred form for a credit/disclaimer
              to use in compliance with this license. We thus encourage you to use the
              following text:
            </p>
            <p>
              """ Portions of this software are copyright © &lt;year&gt; The FreeType
              Project (www.freetype.org). All rights reserved. """
            </p>
            <p>
              Please replace &lt;year&gt; with the value from the FreeType version you
              actually use.
            </p>
            <p>Legal Terms</p>
            <p>0. Definitions</p>
            <p>
              Throughout this license, the terms `package', `FreeType Project', and
              `FreeType archive' refer to the set of files originally distributed by the
              authors (David Turner, Robert Wilhelm, and Werner Lemberg) as the `FreeType
              Project', be they named as alpha, beta or final release.
            </p>
            <p>
              `You' refers to the licensee, or person using the project, where `using' is
              a generic term including compiling the project's source code as well as
              linking it to form a `program' or `executable'. This program is referred to
              as `a program using the FreeType engine'.
            </p>
            <p>
              This license applies to all files distributed in the original FreeType
              Project, including all source code, binaries and documentation, unless
              otherwise stated in the file in its original, unmodified form as
              distributed in the original archive. If you are unsure whether or not a
              particular file is covered by this license, you must contact us to verify
              this.
            </p>
            <p>
              The FreeType Project is copyright (C) 1996-2000 by David Turner, Robert
              Wilhelm, and Werner Lemberg. All rights reserved except as specified below.
            </p>
            <p>1. No Warranty</p>
            <p>
              THE FREETYPE PROJECT IS PROVIDED `AS IS' WITHOUT WARRANTY OF ANY KIND,
              EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF
              MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. IN NO EVENT WILL ANY
              OF THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY DAMAGES CAUSED BY THE
              USE OR THE INABILITY TO USE, OF THE FREETYPE PROJECT.
            </p>
            <p>2. Redistribution</p>
            <p>
              This license grants a worldwide, royalty-free, perpetual and irrevocable
              right and license to use, execute, perform, compile, display, copy, create
              derivative works of, distribute and sublicense the FreeType Project (in
              both source and object code forms) and derivative works thereof for any
              purpose; and to authorize others to exercise some or all of the rights
              granted herein, subject to the following conditions:
            </p>
            <p>
              o Redistribution of source code must retain this license file (`FTL.TXT')
              unaltered; any additions, deletions or changes to the original files must
              be clearly indicated in accompanying documentation. The copyright notices
              of the unaltered, original files must be preserved in all copies of source
              files.
            </p>
            <p>
              o Redistribution in binary form must provide a disclaimer that states that
              the software is based in part of the work of the FreeType Team, in the
              distribution documentation. We also encourage you to put an URL to the
              FreeType web page in your documentation, though this isn't mandatory.
            </p>
            <p>
              These conditions apply to any software derived from or based on the
              FreeType Project, not just the unmodified files. If you use our work, you
              must acknowledge us. However, no fee need be paid to us.
            </p>
            <p>3. Advertising</p>
            <p>
              Neither the FreeType authors and contributors nor you shall use the name of
              the other for commercial, advertising, or promotional purposes without
              specific prior written permission.
            </p>
            <p>
              We suggest, but do not require, that you use one or more of the following
              phrases to refer to this software in your documentation or advertising
              materials: `FreeType Project', `FreeType Engine', `FreeType library', or
              `FreeType Distribution'.
            </p>
            <p>
              As you have not signed this license, you are not required to accept it.
              However, as the FreeType Project is copyrighted material, only this
              license, or another one contracted with the authors, grants you the right
              to use, distribute, and modify it. Therefore, by using, distributing, or
              modifying the FreeType Project, you indicate that you understand and accept
              all the terms of this license.
            </p>
            <p>4. Contacts</p>
            <p>There are two mailing lists related to FreeType:</p>
            <p>o freetype@nongnu.org</p>
            <p>
              Discusses general use and applications of FreeType, as well as future and
              wanted additions to the library and distribution. If you are looking for
              support, start in this list if you haven't found anything to help you in
              the documentation.
            </p>
            <p>o freetype-devel@nongnu.org</p>
            <p>
              Discusses bugs, as well as engine internals, design issues, specific
              licenses, porting, etc.
            </p>
            <p>Our home page can be found at</p>
            <p>http://www.freetype.org</p>
            <p>--- end of FTL.TXT ---</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>garnet</p>
            <p>Copyright 2013 The Fuchsia Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>garnet</p>
            <p>Copyright 2014 The Fuchsia Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>garnet</p>
            <p>Copyright 2017 The Fuchsia Authors.All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>garnet</p>
            <p>tonic</p>
            <p>topaz</p>
            <p>Copyright 2015 The Fuchsia Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>garnet</p>
            <p>tonic</p>
            <p>topaz</p>
            <p>Copyright 2018 The Fuchsia Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>gif</p>
            <p>GNU LESSER GENERAL PUBLIC LICENSE</p>
            <p>Version 2.1, February 1999</p>
            <p>
              See
              <strong>LGPL-2.1</strong> in the
              <strong>Standard OSS License Text</strong>appendix to this document.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>gif</p>
            <p>
              The Graphics Interchange Format(c) is the copyright property of CompuServe
              Incorporated. Only CompuServe Incorporated is authorized to define,
              redefine, enhance, alter, modify or change in any way the definition of the
              format.
            </p>
            <p>
              CompuServe Incorporated hereby grants a limited, non-exclusive,
              royalty-free license for the use of the Graphics Interchange Format(sm) in
              computer software; computer software utilizing GIF(sm) must acknowledge
              ownership of the Graphics Interchange Format and its Service Mark by
              CompuServe Incorporated, in User and Technical Documentation. Computer
              software utilizing GIF, which is distributed or may be distributed without
              User or Technical Documentation must display to the screen or printer a
              message acknowledging ownership of the Graphics Interchange Format and the
              Service Mark by CompuServe Incorporated; in this case, the acknowledgement
              may be displayed in an opening screen or leading banner, or a closing
              screen or trailing banner. A message such as the following may be used:
            </p>
            <p>
              "The Graphics Interchange Format(c) is the Copyright property of CompuServe
              Incorporated. GIF(sm) is a Service Mark property of CompuServe
              Incorporated."
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright (C) 2012 Grigori Goronzy &lt;greg@kinoho.net&gt;</p>
            <p>
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted, provided that the above
              copyright notice and this permission notice appear in all copies.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
              WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
              SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
              WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
              IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 1998-2004 David Turner and Werner Lemberg</p>
            <p>Copyright © 2004,2007,2009 Red Hat, Inc.</p>
            <p>Copyright © 2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 1998-2004 David Turner and Werner Lemberg</p>
            <p>Copyright © 2004,2007,2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 1998-2004 David Turner and Werner Lemberg</p>
            <p>Copyright © 2006 Behdad Esfahbod</p>
            <p>Copyright © 2007,2008,2009 Red Hat, Inc.</p>
            <p>Copyright © 2012,2013 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007 Chris Wilson</p>
            <p>Copyright © 2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 2011,2012 Google, Inc.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007,2008,2009 Red Hat, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007,2008,2009 Red Hat, Inc.</p>
            <p>Copyright © 2010,2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007,2008,2009 Red Hat, Inc.</p>
            <p>Copyright © 2010,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007,2008,2009 Red Hat, Inc.</p>
            <p>Copyright © 2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007,2008,2009 Red Hat, Inc.</p>
            <p>Copyright © 2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007,2008,2009 Red Hat, Inc.</p>
            <p>Copyright © 2012,2013 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007,2008,2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 2010,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007,2008,2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 2010,2012,2013 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007,2008,2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2007,2008,2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 2012,2018 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009 Red Hat, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009 Red Hat, Inc.</p>
            <p>Copyright © 2009 Keith Stribley</p>
            <p>Copyright © 2011 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009 Red Hat, Inc.</p>
            <p>Copyright © 2009 Keith Stribley</p>
            <p>Copyright © 2015 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009 Red Hat, Inc.</p>
            <p>Copyright © 2011 Codethink Limited</p>
            <p>Copyright © 2010,2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009 Red Hat, Inc.</p>
            <p>Copyright © 2011 Codethink Limited</p>
            <p>Copyright © 2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009 Red Hat, Inc.</p>
            <p>Copyright © 2011 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009 Red Hat, Inc.</p>
            <p>Copyright © 2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009 Red Hat, Inc.</p>
            <p>Copyright © 2015 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009 Red Hat, Inc.</p>
            <p>Copyright © 2018 Ebrahim Byagowi</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009 Red Hat, Inc.</p>
            <p>Copyright © 2018 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 2010,2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 2010,2011,2012,2013 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 2010,2011,2013 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2010 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2010 Red Hat, Inc.</p>
            <p>Copyright © 2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2010,2011 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2010,2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2010,2011,2013 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2010,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2011 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2011 Martin Hosken</p>
            <p>Copyright © 2011 SIL International</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2011 Martin Hosken</p>
            <p>Copyright © 2011 SIL International</p>
            <p>Copyright © 2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2011,2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2011,2012,2013 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2011,2012,2014 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2011,2014 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2012 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2012 Mozilla Foundation.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2012,2013 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2012,2013 Mozilla Foundation.</p>
            <p>Copyright © 2012,2013 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2012,2017 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2013 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2013 Red Hat, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2014 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2015 Ebrahim Byagowi</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2015 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2015 Mozilla Foundation.</p>
            <p>Copyright © 2015 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2015-2018 Ebrahim Byagowi</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2016 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2016 Google, Inc.</p>
            <p>Copyright © 2018 Ebrahim Byagowi</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2016 Igalia S.L.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2016 Elie Roux &lt;elie.roux@telecom-bretagne.eu&gt;</p>
            <p>Copyright © 2018 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2017 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2018 Ebrahim Byagowi</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2018 Ebrahim Byagowi</p>
            <p>Copyright © 2018 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>Copyright © 2018 Google, Inc.</p>
            <p>This is part of HarfBuzz, a text shaping library.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>HarfBuzz is licensed under the so-called "Old MIT" license. Details follow.</p>
            <p>
              For parts of HarfBuzz that are licensed under different licenses see
              individual files names COPYING in subdirectories where applicable.
            </p>
            <p>Copyright © 2010,2011,2012 Google, Inc.</p>
            <p>Copyright © 2012 Mozilla Foundation</p>
            <p>Copyright © 2011 Codethink Limited</p>
            <p>Copyright © 2008,2010 Nokia Corporation and/or its subsidiary(-ies)</p>
            <p>Copyright © 2009 Keith Stribley</p>
            <p>Copyright © 2009 Martin Hosken and SIL International</p>
            <p>Copyright © 2007 Chris Wilson</p>
            <p>Copyright © 2006 Behdad Esfahbod</p>
            <p>Copyright © 2005 David Turner</p>
            <p>Copyright © 2004,2007,2008,2009,2010 Red Hat, Inc.</p>
            <p>Copyright © 1998-2004 David Turner and Werner Lemberg</p>
            <p>For full copyright notices consult the individual files in the package.</p>
            <p>
              Permission is hereby granted, without written agreement and without license
              or royalty fees, to use, copy, modify, and distribute this software and its
              documentation for any purpose, provided that the above copyright notice and
              the following two paragraphs appear in all copies of this software.
            </p>
            <p>
              IN NO EVENT SHALL THE COPYRIGHT HOLDER BE LIABLE TO ANY PARTY FOR DIRECT,
              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
              USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF THE COPYRIGHT HOLDER
              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>
              THE COPYRIGHT HOLDER SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT
              NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE SOFTWARE PROVIDED HEREUNDER IS ON AN "AS IS" BASIS,
              AND THE COPYRIGHT HOLDER HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,
              UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>harfbuzz</p>
            <p>The contents of this directory are licensed under the following terms:</p>
            <p>
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted, provided that the above
              copyright notice and this permission notice appear in all copies.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
              WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
              SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
              WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
              IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>html</p>
            <p>Copyright (c) 2006-2012 The Authors</p>
            <p>Contributors:</p>
            <p>James Graham - jg307@cam.ac.uk</p>
            <p>Anne van Kesteren - annevankesteren@gmail.com</p>
            <p>Lachlan Hunt - lachlan.hunt@lachy.id.au</p>
            <p>Matt McDonald - kanashii@kanashii.ca</p>
            <p>Sam Ruby - rubys@intertwingly.net</p>
            <p>Ian Hickson (Google) - ian@hixie.ch</p>
            <p>Thomas Broyer - t.broyer@ltgt.net</p>
            <p>Jacques Distler - distler@golem.ph.utexas.edu</p>
            <p>Henri Sivonen - hsivonen@iki.fi</p>
            <p>Adam Barth - abarth@webkit.org</p>
            <p>Eric Seidel - eric@webkit.org</p>
            <p>The Mozilla Foundation (contributions from Henri Sivonen since 2008)</p>
            <p>David Flanagan (Mozilla) - dflanagan@mozilla.com</p>
            <p>Google Inc. (contributed the Dart port) - misc@dartlang.org</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>
              Copyright (c) 1995-2016 International Business Machines Corporation and
              others
            </p>
            <p>All rights reserved.</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, and/or sell
              copies of the Software, and to permit persons to whom the Software is
              furnished to do so, provided that the above copyright notice(s) and this
              permission notice appear in all copies of the Software and that both the
              above copyright notice(s) and this permission notice appear in supporting
              documentation.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF THIRD PARTY RIGHTS.
              IN NO EVENT SHALL THE COPYRIGHT HOLDER OR HOLDERS INCLUDED IN THIS NOTICE
              BE LIABLE FOR ANY CLAIM, OR ANY SPECIAL INDIRECT OR CONSEQUENTIAL DAMAGES,
              OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS,
              WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION,
              ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
              SOFTWARE.
            </p>
            <p>
              Except as contained in this notice, the name of a copyright holder shall
              not be used in advertising or otherwise to promote the sale, use or other
              dealings in this Software without prior written authorization of the
              copyright holder.
            </p>
            <p>
              All trademarks and registered trademarks mentioned herein are the property
              of their respective owners.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright (c) 1998 - 1999 Unicode, Inc. All Rights reserved.</p>
            <p>
              Copyright (C) 2002-2005, International Business Machines Corporation and
              others. All Rights Reserved.
            </p>
            <p>
              This file is provided as-is by Unicode, Inc. (The Unicode Consortium). No
              claims are made as to fitness for any particular purpose. No warranties of
              any kind are expressed or implied. The recipient agrees to determine
              applicability of information provided. If this file has been provided on
              optical media by Unicode, Inc., the sole remedy for any claim will be
              exchange of defective media within 90 days of receipt.
            </p>
            <p>
              Unicode, Inc. hereby grants the right to freely use the information
              supplied in this file in the creation of products supporting the Unicode
              Standard, and to make copies of this file in any form for internal or
              external distribution as long as this notice remains attached.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright (c) 1999 Computer Systems and Communication Lab,</p>
            <p>Institute of Information Science, Academia</p>
            <p>* Sinica. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              . Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              . Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              . Neither the name of the Computer Systems and Communication Lab nor the
              names of its contributors may be used to endorse or promote products
              derived from this software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE REGENTS OR CONTRIBUTORS BE LIABLE FOR
              ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
              DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
              LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
              OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright (c) 1999 TaBE Project.</p>
            <p>Copyright (c) 1999 Pai-Hsiang Hsiao.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              . Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              . Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              . Neither the name of the TaBE Project nor the names of its contributors
              may be used to endorse or promote products derived from this software
              without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE REGENTS OR CONTRIBUTORS BE LIABLE FOR
              ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
              DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
              LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
              OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright (c) 1999 Unicode, Inc. All Rights reserved.</p>
            <p>
              Copyright (C) 2002-2005, International Business Machines Corporation and
              others. All Rights Reserved.
            </p>
            <p>
              This file is provided as-is by Unicode, Inc. (The Unicode Consortium). No
              claims are made as to fitness for any particular purpose. No warranties of
              any kind are expressed or implied. The recipient agrees to determine
              applicability of information provided. If this file has been provided on
              optical media by Unicode, Inc., the sole remedy for any claim will be
              exchange of defective media within 90 days of receipt.
            </p>
            <p>
              Unicode, Inc. hereby grants the right to freely use the information
              supplied in this file in the creation of products supporting the Unicode
              Standard, and to make copies of this file in any form for internal or
              external distribution as long as this notice remains attached.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright (c) 2002 Unicode, Inc. All Rights reserved.</p>
            <p>
              Copyright (C) 2002-2005, International Business Machines Corporation and
              others. All Rights Reserved.
            </p>
            <p>
              This file is provided as-is by Unicode, Inc. (The Unicode Consortium). No
              claims are made as to fitness for any particular purpose. No warranties of
              any kind are expressed or implied. The recipient agrees to determine
              applicability of information provided. If this file has been provided on
              optical media by Unicode, Inc., the sole remedy for any claim will be
              exchange of defective media within 90 days of receipt.
            </p>
            <p>
              Unicode, Inc. hereby grants the right to freely use the information
              supplied in this file in the creation of products supporting the Unicode
              Standard, and to make copies of this file in any form for internal or
              external distribution as long as this notice remains attached.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>
              Copyright (c) 2013 International Business Machines Corporation and others.
              All Rights Reserved.
            </p>
            <p>
              Project:
              <a
                href="http://code.google.com/p/lao-dictionary"
              >http://code.google.com/p/lao-dictionary</a>
            </p>
            <p>
              Dictionary:
              <a
                href="http://lao-dictionary.googlecode.com/git/Lao-Dictionary.txt"
              >http://lao-dictionary.googlecode.com/git/Lao-Dictionary.txt</a>
            </p>
            <p>
              License:
              <a
                href="http://lao-dictionary.googlecode.com/git/Lao-Dictionary-LICENSE.txt"
              >http://lao-dictionary.googlecode.com/git/Lao-Dictionary-LICENSE.txt</a>
            </p>
            <p>(copied below)</p>
            <p>This file is derived from the above dictionary, with slight modifications.</p>
            <p>Copyright (C) 2013 Brian Eugene Wilson, Robert Martin Campbell.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              Redistributions of source code must retain the above copyright notice, this
              list of conditions and the following disclaimer. Redistributions in binary
              form must reproduce the above copyright notice, this list of conditions and
              the following disclaimer in the documentation and/or other materials
              provided with the distribution.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>
              Copyright (c) 2014 International Business Machines Corporation and others.
              All Rights Reserved.
            </p>
            <p>This list is part of a project hosted at:</p>
            <p>github.com/kanyawtech/myanmar-karen-word-lists</p>
            <p>Copyright (c) 2013, LeRoy Benjamin Sharon</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
              Redistributions of source code must retain the above copyright notice, this
              list of conditions and the following disclaimer. Redistributions in binary
              form must reproduce the above copyright notice, this list of conditions and
              the following disclaimer in the documentation and/or other materials
              provided with the distribution.
            </p>
            <p>
              Neither the name Myanmar Karen Word Lists, nor the names of its
              contributors may be used to endorse or promote products derived from this
              software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright (c) IBM Corporation, 2000-2010. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright (c) IBM Corporation, 2000-2011. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright (c) IBM Corporation, 2000-2012. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright (c) IBM Corporation, 2000-2014. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright (c) IBM Corporation, 2000-2016. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright 1996 Chih-Hao Tsai @ Beckman Institute,</p>
            <p>University of Illinois</p>
            <p>
              c-tsai4@uiuc.edu
              <a
                href="http://casper.beckman.uiuc.edu/~c-tsai4"
              >http://casper.beckman.uiuc.edu/~c-tsai4</a>
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>
              Copyright 2000, 2001, 2002, 2003 Nara Institute of Science and Technology.
              All Rights Reserved.
            </p>
            <p>
              Use, reproduction, and distribution of this software is permitted. Any copy
              of this software, whether in its original form or modified, must include
              both the above copyright notice and the following paragraphs.
            </p>
            <p>
              Nara Institute of Science and Technology (NAIST), the copyright holders,
              disclaims all warranties with regard to this software, including all
              implied warranties of merchantability and fitness, in no event shall NAIST
              be liable for any special, indirect or consequential damages or any damages
              whatsoever resulting from loss of use, data or profits, whether in an
              action of contract, negligence or other tortuous action, arising out of or
              in connection with the use or performance of this software.
            </p>
            <p>
              A large portion of the dictionary entries originate from ICOT Free
              Software. The following conditions for ICOT Free Software applies to the
              current dictionary as well.
            </p>
            <p>
              Each User may also freely distribute the Program, whether in its original
              form or modified, to any third party or parties, PROVIDED that the
              provisions of Section 3 ("NO WARRANTY") will ALWAYS appear on, or be
              attached to, the Program, which is distributed substantially in the same
              form as set out herein and that such intended distribution, if actually
              made, will neither violate or otherwise contravene any of the laws and
              regulations of the countries having jurisdiction over the User or the
              intended distribution itself.
            </p>
            <p>NO WARRANTY</p>
            <p>
              The program was produced on an experimental basis in the course of the
              research and development conducted during the project and is provided to
              users as so produced on an experimental basis. Accordingly, the program is
              provided without any warranty whatsoever, whether express, implied,
              statutory or otherwise. The term "warranty" used herein includes, but is
              not limited to, any warranty of the quality, performance, merchantability
              and fitness for a particular purpose of the program and the nonexistence of
              any infringement or violation of any right of any third party.
            </p>
            <p>
              Each user of the program will agree and understand, and be deemed to have
              agreed and understood, that there is no warranty whatsoever for the program
              and, accordingly, the entire risk arising from or otherwise connected with
              the program is assumed by the user.
            </p>
            <p>
              Therefore, neither ICOT, the copyright holder, or any other organization
              that participated in or was otherwise related to the development of the
              program and their respective officials, directors, officers and other
              employees shall be held liable for any and all damages, including, without
              limitation, general, special, incidental and consequential damages, arising
              out of or otherwise in connection with the use or inability to use the
              program or any product, material or result produced or otherwise obtained
              by using the program, regardless of whether they have been advised of, or
              otherwise had knowledge of, the possibility of such damages at any time
              during the project or thereafter. Each user will be deemed to have agreed
              to the foregoing by his or her commencement of use of the program. The term
              "use" as used herein includes, but is not limited to, the use,
              modification, copying and distribution of the program and the production of
              secondary products from the program.
            </p>
            <p>
              In the case where the program, whether in its original form or modified,
              was distributed or delivered to or received by a user from any person,
              organization or entity other than ICOT, unless it makes or grants
              independently of ICOT any specific warranty to the user in writing, such
              person, organization or entity, will also be exempted from and not be held
              liable to the user for any such damages as noted above as far as the
              program is concerned.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright 2006-2011, the V8 project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Copyright © 1991-2018 Unicode, Inc. All rights reserved.</p>
            <p>
              Distributed under the Terms of Use in
              http://www.unicode.org/copyright.html.
            </p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of the Unicode data files and any associated documentation (the "Data
              Files") or Unicode software and any associated documentation (the
              "Software") to deal in the Data Files or Software without restriction,
              including without limitation the rights to use, copy, modify, merge,
              publish, distribute, and/or sell copies of the Data Files or Software, and
              to permit persons to whom the Data Files or Software are furnished to do
              so, provided that either (a) this copyright and permission notice appear
              with all copies of the Data Files or Software, or (b) this copyright and
              permission notice appear in associated Documentation.
            </p>
            <p>
              THE DATA FILES AND SOFTWARE ARE PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
              KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF
              THIRD PARTY RIGHTS. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR HOLDERS
              INCLUDED IN THIS NOTICE BE LIABLE FOR ANY CLAIM, OR ANY SPECIAL INDIRECT OR
              CONSEQUENTIAL DAMAGES, OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF
              USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
              TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
              PERFORMANCE OF THE DATA FILES OR SOFTWARE.
            </p>
            <p>
              Except as contained in this notice, the name of a copyright holder shall
              not be used in advertising or otherwise to promote the sale, use or other
              dealings in these Data Files or Software without prior written
              authorization of the copyright holder.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>ICU License - ICU 1.8.1 and later</p>
            <p>COPYRIGHT AND PERMISSION NOTICE</p>
            <p>
              Copyright (c) 1995-2009 International Business Machines Corporation and
              others
            </p>
            <p>All rights reserved.</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, and/or sell
              copies of the Software, and to permit persons to whom the Software is
              furnished to do so, provided that the above copyright notice(s) and this
              permission notice appear in all copies of the Software and that both the
              above copyright notice(s) and this permission notice appear in supporting
              documentation.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF THIRD PARTY RIGHTS.
              IN NO EVENT SHALL THE COPYRIGHT HOLDER OR HOLDERS INCLUDED IN THIS NOTICE
              BE LIABLE FOR ANY CLAIM, OR ANY SPECIAL INDIRECT OR CONSEQUENTIAL DAMAGES,
              OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS,
              WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION,
              ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
              SOFTWARE.
            </p>
            <p>
              Except as contained in this notice, the name of a copyright holder shall
              not be used in advertising or otherwise to promote the sale, use or other
              dealings in this Software without prior written authorization of the
              copyright holder.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>The BSD License</p>
            <p>http://opensource.org/licenses/bsd-license.php</p>
            <p>Copyright (C) 2006-2008, Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              Redistributions of source code must retain the above copyright notice, this
              list of conditions and the following disclaimer.
            </p>
            <p>
              Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>icu</p>
            <p>Unicode® Terms of Use</p>
            <p>
              For the general privacy policy governing access to this site, see the
              Unicode Privacy Policy. For trademark usage, see the Unicode® Consortium
              Name and Trademark Usage Policy.
            </p>
            <p>A. Unicode Copyright.</p>
            <p>1. Copyright © 1991-2017 Unicode, Inc. All rights reserved.</p>
            <p>
              2. Certain documents and files on this website contain a legend indicating
              that "Modification is permitted." Any person is hereby authorized, without
              fee, to modify such documents and files to create derivative works
              conforming to the Unicode® Standard, subject to Terms and Conditions
              herein.
            </p>
            <p>
              3. Any person is hereby authorized, without fee, to view, use, reproduce,
              and distribute all documents and files solely for informational purposes
              and in the creation of products supporting the Unicode Standard, subject to
              the Terms and Conditions herein.
            </p>
            <p>
              4. Further specifications of rights and restrictions pertaining to the use
              of the particular set of data files known as the "Unicode Character
              Database" can be found in the License.
            </p>
            <p>
              5. Each version of the Unicode Standard has further specifications of
              rights and restrictions of use. For the book editions (Unicode 5.0 and
              earlier), these are found on the back of the title page. The online code
              charts carry specific restrictions. All other files, including online
              documentation of the core specification for Unicode 6.0 and later, are
              covered under these general Terms of Use.
            </p>
            <p>
              6. No license is granted to "mirror" the Unicode website where a fee is
              charged for access to the "mirror" site.
            </p>
            <p>
              7. Modification is not permitted with respect to this document. All copies
              of this document must be verbatim.
            </p>
            <p>
              B. Restricted Rights Legend. Any technical data or software which is
              licensed to the United States of America, its agencies and/or
              instrumentalities under this Agreement is commercial technical data or
              commercial computer software developed exclusively at private expense as
              defined in FAR 2.101, or DFARS 252.227-7014 (June 1995), as applicable. For
              technical data, use, duplication, or disclosure by the Government is
              subject to restrictions as set forth in DFARS 202.227-7015 Technical Data,
              Commercial and Items (Nov 1995) and this Agreement. For Software, in
              accordance with FAR 12-212 or DFARS 227-7202, as applicable, use,
              duplication or disclosure by the Government is subject to the restrictions
              set forth in this Agreement.
            </p>
            <p>C. Warranties and Disclaimers.</p>
            <p>
              1. This publication and/or website may include technical or typographical
              errors or other inaccuracies . Changes are periodically added to the
              information herein; these changes will be incorporated in new editions of
              the publication and/or website. Unicode may make improvements and/or
              changes in the product(s) and/or program(s) described in this publication
              and/or website at any time.
            </p>
            <p>
              2. If this file has been purchased on magnetic or optical media from
              Unicode, Inc. the sole and exclusive remedy for any claim will be exchange
              of the defective media within ninety (90) days of original purchase.
            </p>
            <p>
              3. EXCEPT AS PROVIDED IN SECTION C.2, THIS PUBLICATION AND/OR SOFTWARE IS
              PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND EITHER EXPRESS, IMPLIED, OR
              STATUTORY, INCLUDING, BUT NOT LIMITED TO, ANY WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
              UNICODE AND ITS LICENSORS ASSUME NO RESPONSIBILITY FOR ERRORS OR OMISSIONS
              IN THIS PUBLICATION AND/OR SOFTWARE OR OTHER DOCUMENTS WHICH ARE REFERENCED
              BY OR LINKED TO THIS PUBLICATION OR THE UNICODE WEBSITE.
            </p>
            <p>
              D. Waiver of Damages. In no event shall Unicode or its licensors be liable
              for any special, incidental, indirect or consequential damages of any kind,
              or any damages whatsoever, whether or not Unicode was advised of the
              possibility of the damage, including, without limitation, those resulting
              from the following: loss of use, data or profits, in connection with the
              use, modification or distribution of this information or its derivatives.
            </p>
            <p>E. Trademarks &amp; Logos.</p>
            <p>
              1. The Unicode Word Mark and the Unicode Logo are trademarks of Unicode,
              Inc. “The Unicode Consortium” and “Unicode, Inc.” are trade names of
              Unicode, Inc. Use of the information and materials found on this website
              indicates your acknowledgement of Unicode, Inc.’s exclusive worldwide
              rights in the Unicode Word Mark, the Unicode Logo, and the Unicode trade
              names.
            </p>
            <p>
              2. The Unicode Consortium Name and Trademark Usage Policy (“Trademark
              Policy”) are incorporated herein by reference and you agree to abide by the
              provisions of the Trademark Policy, which may be changed from time to time
              in the sole discretion of Unicode, Inc.
            </p>
            <p>
              3. All third party trademarks referenced herein are the property of their
              respective owners.
            </p>
            <p>F. Miscellaneous.</p>
            <p>
              1. Jurisdiction and Venue. This server is operated from a location in the
              State of California, United States of America. Unicode makes no
              representation that the materials are appropriate for use in other
              locations. If you access this server from other locations, you are
              responsible for compliance with local laws. This Agreement, all use of this
              site and any claims and damages resulting from use of this site are
              governed solely by the laws of the State of California without regard to
              any principles which would apply the laws of a different jurisdiction. The
              user agrees that any disputes regarding this site shall be resolved solely
              in the courts located in Santa Clara County, California. The user agrees
              said courts have personal jurisdiction and agree to waive any right to
              transfer the dispute to any other forum.
            </p>
            <p>
              2. Modification by Unicode Unicode shall have the right to modify this
              Agreement at any time by posting it to this site. The user may not assign
              any part of this Agreement without Unicode’s prior written consent.
            </p>
            <p>
              3. Taxes. The user agrees to pay any taxes arising from access to this
              website or use of the information herein, except for those based on
              Unicode’s net income.
            </p>
            <p>
              4. Severability. If any provision of this Agreement is declared invalid or
              unenforceable, the remaining provisions of this Agreement shall remain in
              effect.
            </p>
            <p>
              5. Entire Agreement. This Agreement constitutes the entire agreement
              between the parties.
            </p>
            <p>EXHIBIT 1</p>
            <p>UNICODE, INC. LICENSE AGREEMENT - DATA FILES AND SOFTWARE</p>
            <p>Unicode Data Files include all data files under the directories</p>
            <p>
              http://www.unicode.org/Public/,
              <a
                href="http://www.unicode.org/reports/"
              >http://www.unicode.org/reports/</a>
              ,
            </p>
            <p>
              http://www.unicode.org/cldr/data/,
              <a
                href="http://source.icu-project.org/repos/icu/"
              >http://source.icu-project.org/repos/icu/</a>
              , and
            </p>
            <p>
              <a
                href="http://www.unicode.org/utility/trac/browser/"
              >http://www.unicode.org/utility/trac/browser/</a>
              .
            </p>
            <p>
              Unicode Data Files do not include PDF online code charts under the
              directory
              <a
                href="http://www.unicode.org/Public/"
              >http://www.unicode.org/Public/</a>
              .
            </p>
            <p>
              Software includes any source code published in the Unicode Standard or
              under the directories
            </p>
            <p>
              http://www.unicode.org/Public/,
              <a
                href="http://www.unicode.org/reports/"
              >http://www.unicode.org/reports/</a>
              ,
            </p>
            <p>
              http://www.unicode.org/cldr/data/,
              <a
                href="http://source.icu-project.org/repos/icu/"
              >http://source.icu-project.org/repos/icu/</a>
              , and
            </p>
            <p>
              <a
                href="http://www.unicode.org/utility/trac/browser/"
              >http://www.unicode.org/utility/trac/browser/</a>
              .
            </p>
            <p>
              NOTICE TO USER: Carefully read the following legal agreement. BY
              DOWNLOADING, INSTALLING, COPYING OR OTHERWISE USING UNICODE INC.'S DATA
              FILES ("DATA FILES"), AND/OR SOFTWARE ("SOFTWARE"), YOU UNEQUIVOCALLY
              ACCEPT, AND AGREE TO BE BOUND BY, ALL OF THE TERMS AND CONDITIONS OF THIS
              AGREEMENT. IF YOU DO NOT AGREE, DO NOT DOWNLOAD, INSTALL, COPY, DISTRIBUTE
              OR USE THE DATA FILES OR SOFTWARE.
            </p>
            <p>COPYRIGHT AND PERMISSION NOTICE</p>
            <p>Copyright © 1991-2017 Unicode, Inc. All rights reserved.</p>
            <p>
              Distributed under the Terms of Use in
              <a
                href="http://www.unicode.org/copyright.html"
              >http://www.unicode.org/copyright.html</a>
              .
            </p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of the Unicode data files and any associated documentation (the "Data
              Files") or Unicode software and any associated documentation (the
              "Software") to deal in the Data Files or Software without restriction,
              including without limitation the rights to use, copy, modify, merge,
              publish, distribute, and/or sell copies of the Data Files or Software, and
              to permit persons to whom the Data Files or Software are furnished to do
              so, provided that either (a) this copyright and permission notice appear
              with all copies of the Data Files or Software, or (b) this copyright and
              permission notice appear in associated Documentation.
            </p>
            <p>
              THE DATA FILES AND SOFTWARE ARE PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
              KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF
              THIRD PARTY RIGHTS. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR HOLDERS
              INCLUDED IN THIS NOTICE BE LIABLE FOR ANY CLAIM, OR ANY SPECIAL INDIRECT OR
              CONSEQUENTIAL DAMAGES, OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF
              USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
              TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
              PERFORMANCE OF THE DATA FILES OR SOFTWARE.
            </p>
            <p>
              Except as contained in this notice, the name of a copyright holder shall
              not be used in advertising or otherwise to promote the sale, use or other
              dealings in these Data Files or Software without prior written
              authorization of the copyright holder.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>io</p>
            <p>multi_server_socket</p>
            <p>term_glyph</p>
            <p>Copyright 2017, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>jaguar_resty</p>
            <p>BSD 3-Clause License</p>
            <p>Copyright (c) 2017, Ravi Teja Gudapati &lt;tejainece@gmail.com&gt;</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of the copyright holder nor the names of its
              contributors may be used to endorse or promote products derived from this
              software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>jaguar_retrofit</p>
            <p>Copyright (c) 2016, Jaguar Authors.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Jaguar Authors nor the names of its contributors may
              be used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL Jaguar Authors BE LIABLE FOR ANY DIRECT,
              INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
              LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
              OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>js</p>
            <p>Copyright 2012, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2009, D. R. Commander.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2009-2011, 2014-2016, D. R. Commander.</p>
            <p>Copyright (C) 2015, Matthieu Darbois.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2009-2011, Nokia Corporation and/or its subsidiary(-ies).</p>
            <p>All Rights Reserved.</p>
            <p>Author: Siarhei Siamashka &lt;siarhei.siamashka@nokia.com&gt;</p>
            <p>Copyright (C) 2013-2014, Linaro Limited. All Rights Reserved.</p>
            <p>Author: Ragesh Radhakrishnan &lt;ragesh.r@linaro.org&gt;</p>
            <p>Copyright (C) 2014-2016, D. R. Commander. All Rights Reserved.</p>
            <p>Copyright (C) 2015-2016, Matthieu Darbois. All Rights Reserved.</p>
            <p>Copyright (C) 2016, Siarhei Siamashka. All Rights Reserved.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2009-2011, Nokia Corporation and/or its subsidiary(-ies).</p>
            <p>All Rights Reserved.</p>
            <p>Author: Siarhei Siamashka &lt;siarhei.siamashka@nokia.com&gt;</p>
            <p>Copyright (C) 2014, Siarhei Siamashka. All Rights Reserved.</p>
            <p>Copyright (C) 2014, Linaro Limited. All Rights Reserved.</p>
            <p>Copyright (C) 2015, D. R. Commander. All Rights Reserved.</p>
            <p>Copyright (C) 2015-2016, Matthieu Darbois. All Rights Reserved.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2011, D. R. Commander.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2013, MIPS Technologies, Inc., California.</p>
            <p>All Rights Reserved.</p>
            <p>Authors: Teodora Novkovic (teodora.novkovic@imgtec.com)</p>
            <p>Darko Laus (darko.laus@imgtec.com)</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2013-2014, MIPS Technologies, Inc., California.</p>
            <p>All Rights Reserved.</p>
            <p>Authors: Teodora Novkovic (teodora.novkovic@imgtec.com)</p>
            <p>Darko Laus (darko.laus@imgtec.com)</p>
            <p>Copyright (C) 2015, D. R. Commander. All Rights Reserved.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2014, D. R. Commander. All Rights Reserved.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2014-2015, D. R. Commander. All Rights Reserved.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2014-2015, D. R. Commander. All Rights Reserved.</p>
            <p>Copyright (C) 2014, Jay Foad. All Rights Reserved.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C) 2015, D. R. Commander. All Rights Reserved.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C)2009-2014 D. R. Commander. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              - Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              - Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              - Neither the name of the libjpeg-turbo Project nor the names of its
              contributors may be used to endorse or promote products derived from this
              software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
              IS", AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
              THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS OR
              CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
              EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
              PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS;
              OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
              WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
              OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C)2009-2015 D. R. Commander. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              - Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              - Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              - Neither the name of the libjpeg-turbo Project nor the names of its
              contributors may be used to endorse or promote products derived from this
              software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
              IS", AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
              THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS OR
              CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
              EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
              PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS;
              OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
              WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
              OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C)2009-2016 D. R. Commander. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              - Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              - Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              - Neither the name of the libjpeg-turbo Project nor the names of its
              contributors may be used to endorse or promote products derived from this
              software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
              IS", AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
              THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS OR
              CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
              EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
              PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS;
              OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
              WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
              OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C)2011 D. R. Commander. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              - Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              - Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              - Neither the name of the libjpeg-turbo Project nor the names of its
              contributors may be used to endorse or promote products derived from this
              software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
              IS", AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
              THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS OR
              CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
              EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
              PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS;
              OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
              WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
              OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C)2011, 2015 D. R. Commander. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              - Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              - Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              - Neither the name of the libjpeg-turbo Project nor the names of its
              contributors may be used to endorse or promote products derived from this
              software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
              IS", AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
              THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS OR
              CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
              EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
              PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS;
              OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
              WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
              OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright (C)2011-2016 D. R. Commander. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              - Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              - Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              - Neither the name of the libjpeg-turbo Project nor the names of its
              contributors may be used to endorse or promote products derived from this
              software without specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
              IS", AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
              THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS OR
              CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
              EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
              PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS;
              OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
              WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
              OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library,</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2009, D. R. Commander.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2009-2011, 2013-2014, 2016, D. R. Commander.</p>
            <p>Copyright (C) 2015, Matthieu Darbois.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library,</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2009-2011, 2013-2014, 2016, D. R. Commander.</p>
            <p>Copyright (C) 2015-2016, Matthieu Darbois.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library,</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2009-2011, 2014, 2016, D. R. Commander.</p>
            <p>Copyright (C) 2015, Matthieu Darbois.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library,</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2009-2011, 2014, D. R. Commander.</p>
            <p>Copyright (C) 2013-2014, MIPS Technologies, Inc., California.</p>
            <p>Copyright (C) 2015, Matthieu Darbois.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library,</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2009-2011, 2014, D. R. Commander.</p>
            <p>Copyright (C) 2015, Matthieu Darbois.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library,</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>2. Altered source versions must be plainly marked as such, and must not be</p>
            <p>misrepresented as being the original software.</p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2009-2011, 2014-2015, D. R. Commander.</p>
            <p>Copyright (C) 2015, Matthieu Darbois.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library,</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2010, D. R. Commander.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library - version 1.02</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2011, 2014, D. R. Commander.</p>
            <p>Copyright (C) 2015, Matthieu Darbois.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library,</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2011, 2014-2016, D. R. Commander.</p>
            <p>Copyright (C) 2013-2014, MIPS Technologies, Inc., California.</p>
            <p>Copyright (C) 2014, Linaro Limited.</p>
            <p>Copyright (C) 2015-2016, Matthieu Darbois.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library,</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2011, D. R. Commander.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009, 2012 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2009, 2012, D. R. Commander.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>Copyright 2009, 2012 Pierre Ossman &lt;ossman@cendio.se&gt; for Cendio AB</p>
            <p>Copyright (C) 2012, D. R. Commander.</p>
            <p>Based on the x86 SIMD extension for IJG JPEG library</p>
            <p>Copyright (C) 1999-2006, MIYASAKA Masaru.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libjpeg-turbo</p>
            <p>
              libjpeg-turbo note: This file has been modified by The libjpeg-turbo
              Project to include only information relevant to libjpeg-turbo, to wordsmith
              certain sections, and to remove impolitic language that existed in the
              libjpeg v8 README. It is included only for reference. Please see README.md
              for information specific to libjpeg-turbo.
            </p>
            <p>The Independent JPEG Group's JPEG software</p>
            <p>==========================================</p>
            <p>
              This distribution contains a release of the Independent JPEG Group's free
              JPEG software. You are welcome to redistribute this software and to use it
              for any purpose, subject to the conditions under LEGAL ISSUES, below.
            </p>
            <p>
              This software is the work of Tom Lane, Guido Vollbeding, Philip Gladstone,
              Bill Allombert, Jim Boucher, Lee Crocker, Bob Friesenhahn, Ben Jackson,
              Julian Minguillon, Luis Ortiz, George Phillips, Davide Rossi, Ge' Weijers,
              and other members of the Independent JPEG Group.
            </p>
            <p>
              IJG is not affiliated with the ISO/IEC JTC1/SC29/WG1 standards committee
              (also known as JPEG, together with ITU-T SG16).
            </p>
            <p>DOCUMENTATION ROADMAP</p>
            <p>=====================</p>
            <p>This file contains the following sections:</p>
            <p>OVERVIEW General description of JPEG and the IJG software.</p>
            <p>LEGAL ISSUES Copyright, lack of warranty, terms of distribution.</p>
            <p>REFERENCES Where to learn more about JPEG.</p>
            <p>ARCHIVE LOCATIONS Where to find newer versions of this software.</p>
            <p>FILE FORMAT WARS Software *not* to get.</p>
            <p>TO DO Plans for future IJG releases.</p>
            <p>Other documentation files in the distribution are:</p>
            <p>User documentation:</p>
            <p>usage.txt Usage instructions for cjpeg, djpeg, jpegtran,</p>
            <p>rdjpgcom, and wrjpgcom.</p>
            <p>*.1 Unix-style man pages for programs (same info as usage.txt).</p>
            <p>wizard.txt Advanced usage instructions for JPEG wizards only.</p>
            <p>change.log Version-to-version change highlights.</p>
            <p>Programmer and internal documentation:</p>
            <p>libjpeg.txt How to use the JPEG library in your own programs.</p>
            <p>example.c Sample code for calling the JPEG library.</p>
            <p>structure.txt Overview of the JPEG library's internal structure.</p>
            <p>coderules.txt Coding style rules --- please read if you contribute code.</p>
            <p>
              Please read at least usage.txt. Some information can also be found in the
              JPEG
            </p>
            <p>
              FAQ (Frequently Asked Questions) article. See ARCHIVE LOCATIONS below to
              find
            </p>
            <p>out where to obtain the FAQ article.</p>
            <p>
              If you want to understand how the JPEG code works, we suggest reading one
              or
            </p>
            <p>more of the REFERENCES, then looking at the documentation files (in roughly</p>
            <p>the order listed) before diving into the code.</p>
            <p>OVERVIEW</p>
            <p>========</p>
            <p>
              This package contains C software to implement JPEG image encoding,
              decoding,
            </p>
            <p>and transcoding. JPEG (pronounced "jay-peg") is a standardized compression</p>
            <p>
              method for full-color and grayscale images. JPEG's strong suit is
              compressing
            </p>
            <p>photographic images or other types of images that have smooth color and</p>
            <p>
              brightness transitions between neighboring pixels. Images with sharp lines
              or
            </p>
            <p>other abrupt features may not compress well with JPEG, and a higher JPEG</p>
            <p>
              quality may have to be used to avoid visible compression artifacts with
              such
            </p>
            <p>images.</p>
            <p>
              JPEG is lossy, meaning that the output pixels are not necessarily identical
              to
            </p>
            <p>
              the input pixels. However, on photographic content and other "smooth"
              images,
            </p>
            <p>very good compression ratios can be obtained with no visible compression</p>
            <p>artifacts, and extremely high compression ratios are possible if you are</p>
            <p>
              willing to sacrifice image quality (by reducing the "quality" setting in
              the
            </p>
            <p>compressor.)</p>
            <p>
              This software implements JPEG baseline, extended-sequential, and
              progressive
            </p>
            <p>
              compression processes. Provision is made for supporting all variants of
              these
            </p>
            <p>
              processes, although some uncommon parameter settings aren't implemented
              yet.
            </p>
            <p>We have made no provision for supporting the hierarchical or lossless</p>
            <p>processes defined in the standard.</p>
            <p>
              We provide a set of library routines for reading and writing JPEG image
              files,
            </p>
            <p>plus two sample applications "cjpeg" and "djpeg", which use the library to</p>
            <p>perform conversion between JPEG and some other popular image file formats.</p>
            <p>The library is intended to be reused in other applications.</p>
            <p>In order to support file conversion and viewing software, we have included</p>
            <p>considerable functionality beyond the bare JPEG coding/decoding capability;</p>
            <p>for example, the color quantization modules are not strictly part of JPEG</p>
            <p>decoding, but they are essential for output to colormapped file formats or</p>
            <p>colormapped displays. These extra functions can be compiled out of the</p>
            <p>library if not required for a particular application.</p>
            <p>
              We have also included "jpegtran", a utility for lossless transcoding
              between
            </p>
            <p>different JPEG processes, and "rdjpgcom" and "wrjpgcom", two simple</p>
            <p>applications for inserting and extracting textual comments in JFIF files.</p>
            <p>
              The emphasis in designing this software has been on achieving portability
              and
            </p>
            <p>flexibility, while also making it fast enough to be useful. In particular,</p>
            <p>the software is not intended to be read as a tutorial on JPEG. (See the</p>
            <p>REFERENCES section for introductory material.) Rather, it is intended to</p>
            <p>be reliable, portable, industrial-strength code. We do not claim to have</p>
            <p>achieved that goal in every aspect of the software, but we strive for it.</p>
            <p>We welcome the use of this software as a component of commercial products.</p>
            <p>No royalty is required, but we do ask for an acknowledgement in product</p>
            <p>documentation, as described under LEGAL ISSUES.</p>
            <p>LEGAL ISSUES</p>
            <p>============</p>
            <p>In plain English:</p>
            <p>1. We don't promise that this software works. (But if you find any bugs,</p>
            <p>please let us know!)</p>
            <p>
              2. You can use this software for whatever you want. You don't have to pay
              us.
            </p>
            <p>3. You may not pretend that you wrote this software. If you use it in a</p>
            <p>program, you must acknowledge somewhere in your documentation that</p>
            <p>you've used the IJG code.</p>
            <p>In legalese:</p>
            <p>
              The authors make NO WARRANTY or representation, either express or implied,
              with respect to this software, its quality, accuracy, merchantability, or
              fitness for a particular purpose. This software is provided "AS IS", and
              you, its user, assume the entire risk as to its quality and accuracy.
            </p>
            <p>
              This software is copyright (C) 1991-2016, Thomas G. Lane, Guido Vollbeding.
              All Rights Reserved except as specified below.
            </p>
            <p>
              Permission is hereby granted to use, copy, modify, and distribute this
              software (or portions thereof) for any purpose, without fee, subject to
              these conditions:
            </p>
            <p>
              (1) If any part of the source code for this software is distributed, then
              this README file must be included, with this copyright and no-warranty
              notice unaltered; and any additions, deletions, or changes to the original
              files must be clearly indicated in accompanying documentation.
            </p>
            <p>
              (2) If only executable code is distributed, then the accompanying
              documentation must state that "this software is based in part on the work
              of the Independent JPEG Group".
            </p>
            <p>
              (3) Permission for use of this software is granted only if the user accepts
              full responsibility for any undesirable consequences; the authors accept NO
              LIABILITY for damages of any kind.
            </p>
            <p>
              These conditions apply to any software derived from or based on the IJG
              code, not just to the unmodified library. If you use our work, you ought to
              acknowledge us.
            </p>
            <p>
              Permission is NOT granted for the use of any IJG author's name or company
              name in advertising or publicity relating to this software or products
              derived from it. This software may be referred to only as "the Independent
              JPEG Group's software".
            </p>
            <p>
              We specifically permit and encourage the use of this software as the basis
              of commercial products, provided that all warranty or liability claims are
              assumed by the product vendor.
            </p>
            <p>
              The Unix configuration script "configure" was produced with GNU Autoconf.
              It is copyright by the Free Software Foundation but is freely
              distributable. The same holds for its supporting scripts (config.guess,
              config.sub, ltmain.sh). Another support script, install-sh, is copyright by
              X Consortium but is also freely distributable.
            </p>
            <p>The IJG distribution formerly included code to read and write GIF files.</p>
            <p>
              To avoid entanglement with the Unisys LZW patent (now expired), GIF reading
              support has been removed altogether, and the GIF writer has been simplified
              to produce "uncompressed GIFs". This technique does not use the LZW
              algorithm; the resulting GIF files are larger than usual, but are readable
              by all standard GIF decoders.
            </p>
            <p>
              We are required to state that "The Graphics Interchange Format(c) is the
              Copyright property of CompuServe Incorporated. GIF(sm) is a Service Mark
              property of CompuServe Incorporated."
            </p>
            <p>REFERENCES</p>
            <p>==========</p>
            <p>
              We recommend reading one or more of these references before trying to
              understand the innards of the JPEG software.
            </p>
            <p>The best short technical introduction to the JPEG compression algorithm is</p>
            <p>Wallace, Gregory K. "The JPEG Still Picture Compression Standard",</p>
            <p>Communications of the ACM, April 1991 (vol. 34 no. 4), pp. 30-44.</p>
            <p>
              (Adjacent articles in that issue discuss MPEG motion picture compression,
              applications of JPEG, and related topics.) If you don't have the CACM issue
              handy, a PDF file containing a revised version of Wallace's article is
              available at http://www.ijg.org/files/Wallace.JPEG.pdf. The file (actually
              a preprint for an article that appeared in IEEE Trans. Consumer
              Electronics) omits the sample images that appeared in CACM, but it includes
              corrections and some added material. Note: the Wallace article is copyright
              ACM and IEEE, and it may not be used for commercial purposes.
            </p>
            <p>
              A somewhat less technical, more leisurely introduction to JPEG can be found
              in "The Data Compression Book" by Mark Nelson and Jean-loup Gailly,
              published by M&amp;T Books (New York), 2nd ed. 1996, ISBN 1-55851-434-1.
              This book provides good explanations and example C code for a multitude of
              compression methods including JPEG. It is an excellent source if you are
              comfortable reading C code but don't know much about data compression in
              general. The book's JPEG sample code is far from industrial-strength, but
              when you are ready to look at a full implementation, you've got one here...
            </p>
            <p>
              The best currently available description of JPEG is the textbook "JPEG
              Still Image Data Compression Standard" by William B. Pennebaker and Joan L.
              Mitchell, published by Van Nostrand Reinhold, 1993, ISBN 0-442-01272-1.
              Price US$59.95, 638 pp. The book includes the complete text of the ISO JPEG
            </p>
            <p>standards (DIS 10918-1 and draft DIS 10918-2).</p>
            <p>
              The original JPEG standard is divided into two parts, Part 1 being the
              actual specification, while Part 2 covers compliance testing methods. Part
              1 is titled "Digital Compression and Coding of Continuous-tone Still
              Images, Part 1: Requirements and guidelines" and has document numbers
              ISO/IEC IS 10918-1, ITU-T T.81. Part 2 is titled "Digital Compression and
              Coding of Continuous-tone Still Images, Part 2: Compliance testing" and has
              document numbers ISO/IEC IS 10918-2, ITU-T T.83.
            </p>
            <p>
              The JPEG standard does not specify all details of an interchangeable file
              format. For the omitted details we follow the "JFIF" conventions, revision
              1.02. JFIF 1.02 has been adopted as an Ecma International Technical Report
              and thus received a formal publication status. It is available as a free
              download in PDF format from
              <a
                href="http://www.ecma-international.org/publications/techreports/E-TR-098.htm"
              >http://www.ecma-international.org/publications/techreports/E-TR-098.htm</a>
              .
            </p>
            <p>
              A PostScript version of the JFIF document is available at
              http://www.ijg.org/files/jfif.ps.gz. There is also a plain text version at
              http://www.ijg.org/files/jfif.txt.gz, but it is missing the figures.
            </p>
            <p>
              The TIFF 6.0 file format specification can be obtained by FTP from
              ftp://ftp.sgi.com/graphics/tiff/TIFF6.ps.gz. The JPEG incorporation scheme
              found in the TIFF 6.0 spec of 3-June-92 has a number of serious problems.
            </p>
            <p>IJG does not recommend use of the TIFF 6.0 design (TIFF Compression tag 6).</p>
            <p>Instead, we recommend the JPEG design proposed by TIFF Technical Note #2</p>
            <p>(Compression tag 7). Copies of this Note can be obtained from</p>
            <p>
              http://www.ijg.org/files/. It is expected that the next revision of the
              TIFF spec will replace the 6.0 JPEG design with the Note's design.
            </p>
            <p>
              Although IJG's own code does not support TIFF/JPEG, the free libtiff
              library uses our library to implement TIFF/JPEG per the Note.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libsdl</p>
            <p>skia</p>
            <p>Copyright 2016 Google Inc.</p>
            <p>Redistribution and use in source and binary forms, with or without</p>
            <p>modification, are permitted provided that the following conditions are</p>
            <p>met:</p>
            <p>* Redistributions of source code must retain the above copyright</p>
            <p>notice, this list of conditions and the following disclaimer.</p>
            <p>* Redistributions in binary form must reproduce the above</p>
            <p>copyright notice, this list of conditions and the following disclaimer</p>
            <p>in the documentation and/or other materials provided with the</p>
            <p>distribution.</p>
            <p>* Neither the name of Google Inc. nor the names of its</p>
            <p>contributors may be used to endorse or promote products derived from</p>
            <p>this software without specific prior written permission.</p>
            <p>THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS</p>
            <p>"AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT</p>
            <p>LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR</p>
            <p>A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT</p>
            <p>OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,</p>
            <p>SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT</p>
            <p>LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,</p>
            <p>DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY</p>
            <p>THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT</p>
            <p>(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE</p>
            <p>OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libwebp</p>
            <p>Copyright (c) 2010, Google Inc. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google nor the names of its contributors may be used
              to endorse or promote products derived from this software without specific
              prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libwebp</p>
            <p>Copyright 2010 Google Inc. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google nor the names of its contributors may be used
              to endorse or promote products derived from this software without specific
              prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libwebp</p>
            <p>Copyright 2011 Google Inc. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google nor the names of its contributors may be used
              to endorse or promote products derived from this software without specific
              prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libwebp</p>
            <p>Copyright 2012 Google Inc. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google nor the names of its contributors may be used
              to endorse or promote products derived from this software without specific
              prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libwebp</p>
            <p>Copyright 2013 Google Inc. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google nor the names of its contributors may be used
              to endorse or promote products derived from this software without specific
              prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libwebp</p>
            <p>Copyright 2014 Google Inc. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google nor the names of its contributors may be used
              to endorse or promote products derived from this software without specific
              prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libwebp</p>
            <p>Copyright 2015 Google Inc. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google nor the names of its contributors may be used
              to endorse or promote products derived from this software without specific
              prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libwebp</p>
            <p>Copyright 2016 Google Inc. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google nor the names of its contributors may be used
              to endorse or promote products derived from this software without specific
              prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>libwebp</p>
            <p>Copyright 2017 Google Inc. All Rights Reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google nor the names of its contributors may be used
              to endorse or promote products derived from this software without specific
              prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>node_preamble</p>
            <p>The MIT License (MIT)</p>
            <p>Copyright (c) 2015 Michael Bullington</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>===</p>
            <p>Copyright 2012, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>
              Copyright (c) 2011, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>
              Copyright (c) 2012, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>Copyright (c) 2013, Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>
              Copyright (c) 2013, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided
            </p>
            <p>with the distribution.</p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>Copyright (c) 2014, Michael Bostock and Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL MICHAEL BOSTOCK BE LIABLE FOR ANY DIRECT,
              INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
              LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
              OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>Copyright (c) 2014, the Dart project authors.</p>
            <p>Please see the AUTHORS file for details. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>
              Copyright (c) 2014, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>
              Copyright (c) 2016, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>Copyright (c) 2017, the Dart project authors.</p>
            <p>Please see the AUTHORS file for details. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>
              Copyright (c) 2017, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>
              Copyright (c) 2018, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>Copyright 2013, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>Copyright 2014, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>Copyright 2015, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>Copyright 2016, the Dart project authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>observatory_pub_packages</p>
            <p>pkg</p>
            <p>
              Copyright (c) 2015, the Dart project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>quiver</p>
            <p>Apache License</p>
            <p>Version 2.0, January 2004</p>
            <p>http://www.apache.org/licenses/</p>
            <p>
              See
              <strong>Apache-2.0</strong> in the
              <strong>Standard OSS License Text</strong> appendix to this document.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>rapidjson</p>
            <p>Copyright (c) 2006-2013 Alexander Chemeris</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              3. Neither the name of the product nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE AUTHOR ``AS IS'' AND ANY EXPRESS OR
              IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES
              OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN
              NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
              SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
              TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
              PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
              LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
              NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>rapidjson</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>root_certificates</p>
            <p>Mozilla Public License</p>
            <p>Version 2.0</p>
            <p>
              See
              <strong>MPL-2.0</strong> in the
              <strong>Standard OSS License Text</strong> appendix to this document.
            </p>
            <p>Exhibit B - “Incompatible With Secondary Licenses” Notice</p>
            <p>
              This Source Code Form is “Incompatible With Secondary Licenses”, as defined
              by the Mozilla Public License, v. 2.0.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>root_certificates</p>
            <p>Mozilla Public License Version 2.0</p>
            <p>==================================</p>
            <p>
              See
              <strong>MPL-2.0</strong> in the
              <strong>Standard OSS License Text</strong> appendix to this document.
            </p>
            <p>Exhibit B - "Incompatible With Secondary Licenses" Notice</p>
            <p>This Source Code Form is "Incompatible With Secondary Licenses", as</p>
            <p>defined by the Mozilla Public License, v. 2.0.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skcms</p>
            <p>Copyright (c) 2018 Google Inc. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skcms</p>
            <p>skia</p>
            <p>vulkan</p>
            <p>vulkanmemoryallocator</p>
            <p>Copyright 2018 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright (C) 2006 Apple Computer, Inc. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY APPLE COMPUTER, INC. ``AS IS'' AND ANY EXPRESS
              OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL APPLE COMPUTER, INC. OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright (C) 2014 Google Inc. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright (c) 2011 Google Inc. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright (c) 2014 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright (c) 2014-2016 The Khronos Group Inc.</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and/or associated documentation files (the
              "Materials"), to deal in the Materials without restriction, including
              without limitation the rights to use, copy, modify, merge, publish,
              distribute, sublicense, and/or sell copies of the Materials, and to permit
              persons to whom the Materials are furnished to do so, subject to the
              following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Materials.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright (c) 2015 The Chromium Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2005 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2006 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2006-2012 The Android Open Source Project</p>
            <p>Copyright 2012 Mozilla Foundation</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2007 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2008 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2008 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2009 Motorola</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2009 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2009-2015 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2010 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2010 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2011 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2011 Google Inc.</p>
            <p>Copyright 2012 Mozilla Foundation</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2011 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2012 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2012 Intel Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2012 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2013 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2013 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2014 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2014 Google Inc.</p>
            <p>Copyright 2017 ARM Ltd.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2014 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2015 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2015 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2016 Mozilla Foundation</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2016 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2017 ARM Ltd.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2017 Google Inc.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2018 Google LLC</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2018 Google LLC.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2018 Google, LLC</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>Copyright 2018 The Android Open Source Project</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>skia</p>
            <p>NEON optimized code (C) COPYRIGHT 2009 Motorola</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>tcmalloc</p>
            <p>Copyright (c) 2003, Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>tcmalloc</p>
            <p>Copyright (c) 2005, Google Inc.</p>
            <p>All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>topaz</p>
            <p>Copyright 2016 The Fuchsia Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              1. Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              2. Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in the
              documentation and/or other materials provided with the distribution.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>topaz</p>
            <p>Copyright 2017 Th%e Fuchsia Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>topaz</p>
            <p>
              Copyright 2017, the Flutter project authors. Please see the AUTHORS file
              for details. All rights reserved.
            </p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>vector_math</p>
            <p>Copyright 2015, Google Inc. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>vulkanmemoryallocator</p>
            <p>Copyright (c) 2017-2018 Advanced Micro Devices, Inc. All rights reserved.</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2003, 2010 Jean-loup Gailly.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2003, 2010 Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2005 Jean-loup Gailly.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2005, 2010 Jean-loup Gailly.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2005, 2010 Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2006, 2010 Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2007 Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2008, 2010 Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2009 Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2010 Jean-loup Gailly</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2010 Jean-loup Gailly</p>
            <p>detect_data_type() function provided freely by Cosmin Truta, 2006</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2010 Jean-loup Gailly and Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2010 Jean-loup Gailly.</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 1995-2010 Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>
              Copyright (C) 1998-2010 Gilles Vollant (minizip) (
              http://www.winimage.com/zLibDll/minizip.html )
            </p>
            <p>Modifications for Zip64 support</p>
            <p>Copyright (C) 2009-2010 Mathias Svensson ( http://result42.com )</p>
            <p>For more info read MiniZip_info.txt</p>
            <p>Condition of use and distribution are the same than zlib :</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>
              Copyright (C) 1998-2010 Gilles Vollant (minizip) (
              http://www.winimage.com/zLibDll/minizip.html )
            </p>
            <p>Modifications of Unzip for Zip64</p>
            <p>Copyright (C) 2007-2008 Even Rouault</p>
            <p>Modifications for Zip64 support on both zip and unzip</p>
            <p>Copyright (C) 2009-2010 Mathias Svensson ( http://result42.com )</p>
            <p>For more info read MiniZip_info.txt</p>
            <p>Condition of use and distribution are the same than zlib :</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 2004, 2005, 2010 Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 2004, 2010 Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 2013 Intel Corporation</p>
            <p>Authors:</p>
            <p>Arjan van de Ven &lt;arjan@linux.intel.com&gt;</p>
            <p>Jim Kukunas &lt;james.t.kukunas@linux.intel.com&gt;</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 2013 Intel Corporation Jim Kukunas</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 2013 Intel Corporation. All rights reserved.</p>
            <p>Author:</p>
            <p>Jim Kukunas</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 2013 Intel Corporation. All rights reserved.</p>
            <p>Authors:</p>
            <p>Wajdi Feghali &lt;wajdi.k.feghali@intel.com&gt;</p>
            <p>Jim Guilford &lt;james.guilford@intel.com&gt;</p>
            <p>Vinodh Gopal &lt;vinodh.gopal@intel.com&gt;</p>
            <p>Erdinc Ozturk &lt;erdinc.ozturk@intel.com&gt;</p>
            <p>Jim Kukunas &lt;james.t.kukunas@linux.intel.com&gt;</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (C) 2014 Intel Corporation</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (c) 2011 The Chromium Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>Copyright (c) 2012 The Chromium Authors. All rights reserved.</p>
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <p>
              * Redistributions of source code must retain the above copyright notice,
              this list of conditions and the following disclaimer.
            </p>
            <p>
              * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            </p>
            <p>
              * Neither the name of Google Inc. nor the names of its contributors may be
              used to endorse or promote products derived from this software without
              specific prior written permission.
            </p>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
              LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
              CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
              SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
              ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p>--------------------------------------------------------------------------------</p>
            <p>zlib</p>
            <p>zlib.h -- interface of the 'zlib' general purpose compression library</p>
            <p>version 1.2.4, March 14th, 2010</p>
            <p>Copyright (C) 1995-2010 Jean-loup Gailly and Mark Adler</p>
            <p>
              This software is provided 'as-is', without any express or implied warranty.
              In no event will the authors be held liable for any damages arising from
              the use of this software.
            </p>
            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <p>
              1. The origin of this software must not be misrepresented; you must not
              claim that you wrote the original software. If you use this software in a
              product, an acknowledgment in the product documentation would be
              appreciated but is not required.
            </p>
            <p>
              2. Altered source versions must be plainly marked as such, and must not be
              misrepresented as being the original software.
            </p>
            <p>3. This notice may not be removed or altered from any source distribution.</p>
            <p>Jean-loup Gailly</p>
            <p>Mark Adler</p>
            <p>/samples/server/petstore-security-test/slim/vendor/slim/slim/LICENSE.md</p>
            <p>Copyright (c) 2011-2016 Josh Lockhart</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/server/petstore/slim/vendor/slim/slim/LICENSE.md:</p>
            <p>Copyright (c) 2011-2016 Josh Lockhart</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/client/petstore/swift3/rxswift/SwaggerClientTests/Pods/RxSwift/LICENSE.md:</p>
            <p>**The MIT License**</p>
            <p>**Copyright © 2015 Krunoslav Zaher**</p>
            <p>**All rights reserved.**</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/samples/client/petstore/swift4/rxswift/SwaggerClientTests/Pods/RxSwift/LICENSE.md:</p>
            <p>**The MIT License**</p>
            <p>**Copyright © 2015 Krunoslav Zaher**</p>
            <p>**All rights reserved.**</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
            <p>/modules/swagger-codegen/src/main/resources/JavaPlayFramework/LICENSE.mustache:</p>
            <p>This software is licensed under the Apache 2 license, quoted below.</p>
            <p>
              Licensed under the Apache License, Version 2.0 (the "License"); you may not
              use this project except in compliance with the License. You may obtain a
              copy of the License at
              <a
                href="http://www.apache.org/licenses/LICENSE-2.0"
              >http://www.apache.org/licenses/LICENSE-2.0</a>
              .
            </p>
            <p>
              Unless required by applicable law or agreed to in writing, software
              distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
              WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
              License for the specific language governing permissions and limitations
              under the License.
            </p>
            <p>
              See
              <strong>Apache-2.0</strong> in the
              <strong>Standard OSS License Text</strong>appendix to this document.
            </p>
            <p>/modules/swagger-codegen/src/main/resources/JavaJaxRS/cxf/licenseInfo.mustache:</p>
            <p>* NOTE: This class is auto generated by the swagger code generator program.</p>
            <p>
              *
              <a
                href="https://github.com/swagger-api/swagger-codegen.git"
              >https://github.com/swagger-api/swagger-codegen.git</a>
            </p>
            <p>* Do not edit the class manually.</p>
            <p>*</p>
            <p>* Licensed under the Apache License, Version 2.0 (the "License");</p>
            <p>* you may not use this file except in compliance with the License.</p>
            <p>* You may obtain a copy of the License at</p>
            <p>*</p>
            <p>* http://www.apache.org/licenses/LICENSE-2.0</p>
            <p>*</p>
            <p>* Unless required by applicable law or agreed to in writing, software</p>
            <p>* distributed under the License is distributed on an "AS IS" BASIS,</p>
            <p>* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.</p>
            <p>* See the License for the specific language governing permissions and</p>
            <p>* limitations under the License.</p>
            <p>*/</p>
            <p>
              See
              <strong>Apache-2.0</strong> in the
              <strong>Standard OSS License Text</strong>appendix to this document.
            </p>
            <p>
              <strong>UCCircularPgoressRing</strong>
            </p>
            <p>
              Package homepage/download site:
              <a
                href="https://github.com/luispadron/UICircularProgressRing/"
              >https://github.com/luispadron/UICircularProgressRing/</a>
            </p>
            <p>Package licensing notices:</p>
            <p>/LICENSE:</p>
            <p>Copyright (c) 2017 Luis Padron</p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a
              copy of this software and associated documentation files (the "Software"),
              to deal in the Software without restriction, including without limitation
              the rights to use, copy, modify, merge, publish, distribute, sublicense,
              and/or sell copies of the Software, and to permit persons to whom the
              Software is furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in
              all copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
              FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.
            </p>
          </a>
          <a id="standardosslicenses">
            <h4>Standard OSS Licenses</h4>
            <p>
              <strong>Apache-2.0</strong>
            </p>
            <p>Apache License</p>
            <p>Version 2.0, January 2004</p>
            <p>http://www.apache.org/licenses/</p>
            <p>TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION</p>
            <p>1. Definitions.</p>
            <p>
              "License" shall mean the terms and conditions for use, reproduction, and
              distribution as defined by Sections 1 through 9 of this document.
            </p>
            <p>
              "Licensor" shall mean the copyright owner or entity authorized by the
              copyright owner that is granting the License.
            </p>
            <p>
              "Legal Entity" shall mean the union of the acting entity and all other
              entities that control, are controlled by, or are under common control with
              that entity. For the purposes of this definition, "control" means (i) the
              power, direct or indirect, to cause the direction or management of such
              entity, whether by contract or otherwise, or (ii) ownership of fifty
              percent (50%) or more of the outstanding shares, or (iii) beneficial
              ownership of such entity.
            </p>
            <p>
              "You" (or "Your") shall mean an individual or Legal Entity exercising
              permissions granted by this License.
            </p>
            <p>
              "Source" form shall mean the preferred form for making modifications,
              including but not limited to software source code, documentation source,
              and configuration files.
            </p>
            <p>
              "Object" form shall mean any form resulting from mechanical transformation
              or translation of a Source form, including but not limited to compiled
              object code, generated documentation, and conversions to other media types.
            </p>
            <p>
              "Work" shall mean the work of authorship, whether in Source or Object form,
              made available under the License, as indicated by a copyright notice that
              is included in or attached to the work (an example is provided in the
              Appendix below).
            </p>
            <p>
              "Derivative Works" shall mean any work, whether in Source or Object form,
              that is based on (or derived from) the Work and for which the editorial
              revisions, annotations, elaborations, or other modifications represent, as
              a whole, an original work of authorship. For the purposes of this License,
              Derivative Works shall not include works that remain separable from, or
              merely link (or bind by name) to the interfaces of, the Work and Derivative
              Works thereof.
            </p>
            <p>
              "Contribution" shall mean any work of authorship, including the original
              version of the Work and any modifications or additions to that Work or
              Derivative Works thereof, that is intentionally submitted to Licensor for
              inclusion in the Work by the copyright owner or by an individual or Legal
              Entity authorized to submit on behalf of the copyright owner. For the
              purposes of this definition, "submitted" means any form of electronic,
              verbal, or written communication sent to the Licensor or its
              representatives, including but not limited to communication on electronic
              mailing lists, source code control systems, and issue tracking systems that
              are managed by, or on behalf of, the Licensor for the purpose of discussing
              and improving the Work, but excluding communication that is conspicuously
              marked or otherwise designated in writing by the copyright owner as "Not a
              Contribution."
            </p>
            <p>
              "Contributor" shall mean Licensor and any individual or Legal Entity on
              behalf of whom a Contribution has been received by Licensor and
              subsequently incorporated within the Work.
            </p>
            <p>
              2. Grant of Copyright License. Subject to the terms and conditions of this
              License, each Contributor hereby grants to You a perpetual, worldwide,
              non-exclusive, no-charge, royalty-free, irrevocable copyright license to
              reproduce, prepare Derivative Works of, publicly display, publicly perform,
              sublicense, and distribute the Work and such Derivative Works in Source or
              Object form.
            </p>
            <p>
              3. Grant of Patent License. Subject to the terms and conditions of this
              License, each Contributor hereby grants to You a perpetual, worldwide,
              non-exclusive, no-charge, royalty-free, irrevocable (except as stated in
              this section) patent license to make, have made, use, offer to sell, sell,
              import, and otherwise transfer the Work, where such license applies only to
              those patent claims licensable by such Contributor that are necessarily
              infringed by their Contribution(s) alone or by combination of their
              Contribution(s) with the Work to which such Contribution(s) was submitted.
              If You institute patent litigation against any entity (including a
              cross-claim or counterclaim in a lawsuit) alleging that the Work or a
              Contribution incorporated within the Work constitutes direct or
              contributory patent infringement, then any patent licenses granted to You
              under this License for that Work shall terminate as of the date such
              litigation is filed.
            </p>
            <p>
              4. Redistribution. You may reproduce and distribute copies of the Work or
              Derivative Works thereof in any medium, with or without modifications, and
              in Source or Object form, provided that You meet the following conditions:
            </p>
            <p>
              You must give any other recipients of the Work or Derivative Works a copy
              of this License; and
            </p>
            <p>
              You must cause any modified files to carry prominent notices stating that
              You changed the files; and
            </p>
            <p>
              You must retain, in the Source form of any Derivative Works that You
              distribute, all copyright, patent, trademark, and attribution notices from
              the Source form of the Work, excluding those notices that do not pertain to
              any part of the Derivative Works; and
            </p>
            <p>
              If the Work includes a "NOTICE" text file as part of its distribution, then
              any Derivative Works that You distribute must include a readable copy of
              the attribution notices contained within such NOTICE file, excluding those
              notices that do not pertain to any part of the Derivative Works, in at
              least one of the following places: within a NOTICE text file distributed as
              part of the Derivative Works; within the Source form or documentation, if
              provided along with the Derivative Works; or, within a display generated by
              the Derivative Works, if and wherever such third-party notices normally
              appear. The contents of the NOTICE file are for informational purposes only
              and do not modify the License. You may add Your own attribution notices
              within Derivative Works that You distribute, alongside or as an addendum to
              the NOTICE text from the Work, provided that such additional attribution
              notices cannot be construed as modifying the License. You may add Your own
              copyright statement to Your modifications and may provide additional or
              different license terms and conditions for use, reproduction, or
              distribution of Your modifications, or for any such Derivative Works as a
              whole, provided Your use, reproduction, and distribution of the Work
              otherwise complies with the conditions stated in this License.
            </p>
            <p>
              5. Submission of Contributions. Unless You explicitly state otherwise, any
              Contribution intentionally submitted for inclusion in the Work by You to
              the Licensor shall be under the terms and conditions of this License,
              without any additional terms or conditions. Notwithstanding the above,
              nothing herein shall supersede or modify the terms of any separate license
              agreement you may have executed with Licensor regarding such Contributions.
            </p>
            <p>
              6. Trademarks. This License does not grant permission to use the trade
              names, trademarks, service marks, or product names of the Licensor, except
              as required for reasonable and customary use in describing the origin of
              the Work and reproducing the content of the NOTICE file.
            </p>
            <p>
              7. Disclaimer of Warranty. Unless required by applicable law or agreed to
              in writing, Licensor provides the Work (and each Contributor provides its
              Contributions) on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
              KIND, either express or implied, including, without limitation, any
              warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or
              FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for
              determining the appropriateness of using or redistributing the Work and
              assume any risks associated with Your exercise of permissions under this
              License.
            </p>
            <p>
              8. Limitation of Liability. In no event and under no legal theory, whether
              in tort (including negligence), contract, or otherwise, unless required by
              applicable law (such as deliberate and grossly negligent acts) or agreed to
              in writing, shall any Contributor be liable to You for damages, including
              any direct, indirect, special, incidental, or consequential damages of any
              character arising as a result of this License or out of the use or
              inability to use the Work (including but not limited to damages for loss of
              goodwill, work stoppage, computer failure or malfunction, or any and all
              other commercial damages or losses), even if such Contributor has been
              advised of the possibility of such damages.
            </p>
            <p>
              9. Accepting Warranty or Additional Liability. While redistributing the
              Work or Derivative Works thereof, You may choose to offer, and charge a fee
              for, acceptance of support, warranty, indemnity, or other liability
              obligations and/or rights consistent with this License. However, in
              accepting such obligations, You may act only on Your own behalf and on Your
              sole responsibility, not on behalf of any other Contributor, and only if
              You agree to indemnify, defend, and hold each Contributor harmless for any
              liability incurred by, or claims asserted against, such Contributor by
              reason of your accepting any such warranty or additional liability.
            </p>
            <p>END OF TERMS AND CONDITIONS</p>
            <p>APPENDIX: How to apply the Apache License to your work</p>
            <p>
              To apply the Apache License to your work, attach the following boilerplate
              notice, with the fields enclosed by brackets "[]" replaced with your own
              identifying information. (Don't include the brackets!) The text should be
              enclosed in the appropriate comment syntax for the file format. We also
              recommend that a file or class name and description of purpose be included
              on the same "printed page" as the copyright notice for easier
              identification within third-party archives.
            </p>
            <p>Copyright [yyyy] [name of copyright owner]</p>
            <p>Licensed under the Apache License, Version 2.0 (the "License");</p>
            <p>you may not use this file except in compliance with the License.</p>
            <p>You may obtain a copy of the License at</p>
            <p>http://www.apache.org/licenses/LICENSE-2.0</p>
            <p>Unless required by applicable law or agreed to in writing, software</p>
            <p>distributed under the License is distributed on an "AS IS" BASIS,</p>
            <p>WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.</p>
            <p>See the License for the specific language governing permissions and</p>
            <p>limitations under the License.</p>
            <p>
              <strong>LGPL-2.1</strong>
            </p>
            <p>GNU LESSER GENERAL PUBLIC LICENSE</p>
            <p>Version 2.1, February 1999</p>
            <p>
              Copyright (C) 1991, 1999 Free Software Foundation, Inc.59 Temple Place,
              Suite 330, Boston, MA 02111-1307 USA Everyone is permitted to copy and
              distribute verbatim copies of this license document, but changing it is not
              allowed.
            </p>
            <p>
              [This is the first released version of the Lesser GPL. It also counts as
              the successor of the GNU Library Public License, version 2, hence the
              version number 2.1.]
            </p>
            <p>Preamble</p>
            <p>
              The licenses for most software are designed to take away your freedom to
              share and change it. By contrast, the GNU General Public Licenses are
              intended to guarantee your freedom to share and change free software--to
              make sure the software is free for all its users.
            </p>
            <p>
              This license, the Lesser General Public License, applies to some specially
              designated software packages--typically libraries--of the Free Software
              Foundation and other authors who decide to use it. You can use it too, but
              we suggest you first think carefully about whether this license or the
              ordinary General Public License is the better strategy to use in any
              particular case, based on the explanations below.
            </p>
            <p>
              When we speak of free software, we are referring to freedom of use, not
              price. Our General Public Licenses are designed to make sure that you have
              the freedom to distribute copies of free software (and charge for this
              service if you wish); that you receive source code or can get it if you
              want it; that you can change the software and use pieces of it in new free
              programs; and that you are informed that you can do these things.
            </p>
            <p>
              To protect your rights, we need to make restrictions that forbid
              distributors to deny you these rights or to ask you to surrender these
              rights. These restrictions translate to certain responsibilities for you if
              you distribute copies of the library or if you modify it.
            </p>
            <p>
              For example, if you distribute copies of the library, whether gratis or for
              a fee, you must give the recipients all the rights that we gave you. You
              must make sure that they, too, receive or can get the source code. If you
              link other code with the library, you must provide complete object files to
              the recipients, so that they can relink them with the library after making
              changes to the library and recompiling it. And you must show them these
              terms so they know their rights.
            </p>
            <p>
              We protect your rights with a two-step method: (1) we copyright the
              library, and (2) we offer you this license, which gives you legal
              permission to copy, distribute and/or modify the library.
            </p>
            <p>
              To protect each distributor, we want to make it very clear that there is no
              warranty for the free library. Also, if the library is modified by someone
              else and passed on, the recipients should know that what they have is not
              the original version, so that the original author's reputation will not be
              affected by problems that might be introduced by others.
            </p>
            <p>
              Finally, software patents pose a constant threat to the existence of any
              free program. We wish to make sure that a company cannot effectively
              restrict the users of a free program by obtaining a restrictive license
              from a patent holder. Therefore, we insist that any patent license obtained
              for a version of the library must be consistent with the full freedom of
              use specified in this license.
            </p>
            <p>
              Most GNU software, including some libraries, is covered by the ordinary GNU
              General Public License. This license, the GNU Lesser General Public
              License, applies to certain designated libraries, and is quite different
              from the ordinary General Public License. We use this license for certain
              libraries in order to permit linking those libraries into non-free
              programs.
            </p>
            <p>
              When a program is linked with a library, whether statically or using a
              shared library, the combination of the two is legally speaking a combined
              work, a derivative of the original library. The ordinary General Public
              License therefore permits such linking only if the entire combination fits
              its criteria of freedom. The Lesser General Public License permits more lax
              criteria for linking other code with the library.
            </p>
            <p>
              We call this license the "Lesser" General Public License because it does
              Less to protect the user's freedom than the ordinary General Public
              License. It also provides other free software developers Less of an
              advantage over competing non-free programs. These disadvantages are the
              reason we use the ordinary General Public License for many libraries.
              However, the Lesser license provides advantages in certain special
              circumstances.
            </p>
            <p>
              For example, on rare occasions, there may be a special need to encourage
              the widest possible use of a certain library, so that it becomes a de-facto
              standard. To achieve this, non-free programs must be allowed to use the
              library. A more frequent case is that a free library does the same job as
              widely used non-free libraries. In this case, there is little to gain by
              limiting the free library to free software only, so we use the Lesser
              General Public License.
            </p>
            <p>
              In other cases, permission to use a particular library in non-free programs
              enables a greater number of people to use a large body of free software.
              For example, permission to use the GNU C Library in non-free programs
              enables many more people to use the whole GNU operating system, as well as
              its variant, the GNU/Linux operating system.
            </p>
            <p>
              Although the Lesser General Public License is Less protective of the users'
              freedom, it does ensure that the user of a program that is linked with the
              Library has the freedom and the wherewithal to run that program using a
              modified version of the Library.
            </p>
            <p>
              The precise terms and conditions for copying, distribution and modification
              follow. Pay close attention to the difference between a "work based on the
              library" and a "work that uses the library". The former contains code
              derived from the library, whereas the latter must be combined with the
              library in order to run.
            </p>
            <p>GNU LESSER GENERAL PUBLIC LICENSE</p>
            <p>TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION</p>
            <p>
              0. This License Agreement applies to any software library or other program
              which contains a notice placed by the copyright holder or other authorized
              party saying it may be distributed under the terms of this Lesser General
              Public License (also called "this License"). Each licensee is addressed as
              "you".
            </p>
            <p>
              A "library" means a collection of software functions and/or data prepared
              so as to be conveniently linked with application programs (which use some
              of those functions and data) to form executables.
            </p>
            <p>
              The "Library", below, refers to any such software library or work which has
              been distributed under these terms. A "work based on the Library" means
              either the Library or any derivative work under copyright law: that is to
              say, a work containing the Library or a portion of it, either verbatim or
              with modifications and/or translated straightforwardly into another
              language. (Hereinafter, translation is included without limitation in the
              term "modification".)
            </p>
            <p>
              "Source code" for a work means the preferred form of the work for making
              modifications to it. For a library, complete source code means all the
              source code for all modules it contains, plus any associated interface
              definition files, plus the scripts used to control compilation and
              installation of the library.
            </p>
            <p>
              Activities other than copying, distribution and modification are not
              covered by this License; they are outside its scope. The act of running a
              program using the Library is not restricted, and output from such a program
              is covered only if its contents constitute a work based on the Library
              (independent of the use of the Library in a tool for writing it). Whether
              that is true depends on what the Library does and what the program that
              uses the Library does.
            </p>
            <p>
              1. You may copy and distribute verbatim copies of the Library's complete
              source code as you receive it, in any medium, provided that you
              conspicuously and appropriately publish on each copy an appropriate
              copyright notice and disclaimer of warranty; keep intact all the notices
              that refer to this License and to the absence of any warranty; and
              distribute a copy of this License along with the Library. You may charge a
              fee for the physical act of transferring a copy, and you may at your option
              offer warranty protection in exchange for a fee.
            </p>
            <p>
              2. You may modify your copy or copies of the Library or any portion of it,
              thus forming a work based on the Library, and copy and distribute such
              modifications or work under the terms of Section 1 above, provided that you
              also meet all of these conditions:
            </p>
            <p>a) The modified work must itself be a software library.</p>
            <p>
              b) You must cause the files modified to carry prominent notices stating
              that you changed the files and the date of any change.
            </p>
            <p>
              c) You must cause the whole of the work to be licensed at no charge to all
              third parties under the terms of this License.
            </p>
            <p>
              d) If a facility in the modified Library refers to a function or a table of
              data to be supplied by an application program that uses the facility, other
              than as an argument passed when the facility is invoked, then you must make
              a good faith effort to ensure that, in the event an application does not
              supply such function or table, the facility still operates, and performs
              whatever part of its purpose remains meaningful. (For example, a function
              in a library to compute square roots has a purpose that is entirely
              well-defined independent of the application. Therefore, Subsection 2d
              requires that any application-supplied function or table used by this
              function must be optional: if the application does not supply it, the
              squareroot function must still compute square roots.)
            </p>
            <p>
              These requirements apply to the modified work as a whole. If identifiable
              sections of that work are not derived from the Library, and can be
              reasonably considered independent and separate works in themselves, then
              this License, and its terms, do not apply to those sections when you
              distribute them as separate works. But when you distribute the same
              sections as part of a whole which is a work based on the Library, the
              distribution of the whole must be on the terms of this License, whose
              permissions for other licensees extend to the entire whole, and thus to
              each and every part regardless of who wrote it.
            </p>
            <p>
              Thus, it is not the intent of this section to claim rights or contest your
              rights to work written entirely by you; rather, the intent is to exercise
              the right to control the distribution of derivative or collective works
              based on the Library.
            </p>
            <p>
              In addition, mere aggregation of another work not based on the Library with
              the Library (or with a work based on the Library) on a volume of a storage
              or distribution medium does not bring the other work under the scope of
              this License.
            </p>
            <p>
              3. You may opt to apply the terms of the ordinary GNU General Public
              License instead of this License to a given copy of the Library. To do this,
              you must alter all the notices that refer to this License, so that they
              refer to the ordinary GNU General Public License, version 2, instead of to
              this License. (If a newer version than version 2 of the ordinary GNU
              General Public License has appeared, then you can specify that version
              instead if you wish.) Do not make any other change in these notices. Once
              this change is made in a given copy, it is irreversible for that copy, so
              the ordinary GNU General Public License applies to all subsequent copies
              and derivative works made from that copy. This option is useful when you
              wish to copy part of the code of the Library into a program that is not a
              library.
            </p>
            <p>
              4. You may copy and distribute the Library (or a portion or derivative of
              it, under Section 2) in object code or executable form under the terms of
              Sections 1 and 2 above provided that you accompany it with the complete
              corresponding machine-readable source code, which must be distributed under
              the terms of Sections 1 and 2 above on a medium customarily used for
              software interchange. If distribution of object code is made by offering
              access to copy from a designated place, then offering equivalent access to
              copy the source code from the same place satisfies the requirement to
              distribute the source code, even though third parties are not compelled to
              copy the source along with the object code.
            </p>
            <p>
              5. A program that contains no derivative of any portion of the Library, but
              is designed to work with the Library by being compiled or linked with it,
              is called a "work that uses the Library". Such a work, in isolation, is not
              a derivative work of the Library, and therefore falls outside the scope of
              this License. However, linking a "work that uses the Library" with the
              Library creates an executable that is a derivative of the Library (because
              it contains portions of the Library), rather than a "work that uses the
              library". The executable is therefore covered by this License. Section 6
              states terms for distribution of such executables. When a "work that uses
              the Library" uses material from a header file that is part of the Library,
              the object code for the work may be a derivative work of the Library even
              though the source code is not. Whether this is true is especially
              significant if the work can be linked without the Library, or if the work
              is itself a library. The threshold for this to be true is not precisely
              defined by law. If such an object file uses only numerical parameters, data
              structure layouts and accessors, and small macros and small inline
              functions (ten lines or less in length), then the use of the object file is
              unrestricted, regardless of whether it is legally a derivative work.
              (Executables containing this object code plus portions of the Library will
              still fall under Section 6.) Otherwise, if the work is a derivative of the
              Library, you may distribute the object code for the work under the terms of
              Section 6. Any executables containing that work also fall under Section 6,
              whether or not they are linked directly with the Library itself.
            </p>
            <p>
              6. As an exception to the Sections above, you may also combine or link a
              "work that uses the Library" with the Library to produce a work containing
              portions of the Library, and distribute that work under terms of your
              choice, provided that the terms permit modification of the work for the
              customer's own use and reverse engineering for debugging such
              modifications. You must give prominent notice with each copy of the work
              that the Library is used in it and that the Library and its use are covered
              by this License. You must supply a copy of this License. If the work during
              execution displays copyright notices, you must include the copyright notice
              for the Library among them, as well as a reference directing the user to
              the copy of this License. Also, you must do one of these things:
            </p>
            <p>
              a) Accompany the work with the complete corresponding machine-readable
              source code for the Library including whatever changes were used in the
              work (which must be distributed under Sections 1 and 2 above); and, if the
              work is an executable linked with the Library, with the complete
              machine-readable "work that uses the Library", as object code and/or source
              code, so that the user can modify the Library and then relink to produce a
              modified executable containing the modified Library. (It is understood that
              the user who changes the contents of definitions files in the Library will
              not necessarily be able to recompile the application to use the modified
              definitions.)
            </p>
            <p>
              b) Use a suitable shared library mechanism for linking with the Library. A
              suitable mechanism is one that (1) uses at run time a copy of the library
              already present on the user's computer system, rather than copying library
              functions into the executable, and (2) will operate properly with a
              modified version of the library, if the user installs one, as long as the
              modified version is interface-compatible with the version that the work was
              made with.
            </p>
            <p>
              c) Accompany the work with a written offer, valid for at least three years,
              to give the same user the materials specified in Subsection 6a, above, for
              a charge no more than the cost of performing this distribution.
            </p>
            <p>
              d) If distribution of the work is made by offering access to copy from a
              designated place, offer equivalent access to copy the above specified
              materials from the same place.
            </p>
            <p>
              e) Verify that the user has already received a copy of these materials or
              that you have already sent this user a copy.
            </p>
            <p>
              For an executable, the required form of the "work that uses the Library"
              must include any data and utility programs needed for reproducing the
              executable from it. However, as a special exception, the materials to be
              distributed need not include anything that is normally distributed (in
              either source or binary form) with the major components (compiler, kernel,
              and so on) of the operating system on which the executable runs, unless
              that component itself accompanies the executable.
            </p>
            <p>
              It may happen that this requirement contradicts the license restrictions of
              other proprietary libraries that do not normally accompany the operating
              system. Such a contradiction means you cannot use both them and the Library
              together in an executable that you distribute.
            </p>
            <p>
              7. You may place library facilities that are a work based on the Library
              side-by-side in a single library together with other library facilities not
              covered by this License, and distribute such a combined library, provided
              that the separate distribution of the work based on the Library and of the
              other library facilities is otherwise permitted, and provided that you do
              these two things:
            </p>
            <p>
              a) Accompany the combined library with a copy of the same work based on the
              Library, uncombined with any other library facilities. This must be
              distributed under the terms of the Sections above.
            </p>
            <p>
              b) Give prominent notice with the combined library of the fact that part of
              it is a work based on the Library, and explaining where to find the
              accompanying uncombined form of the same work.
            </p>
            <p>
              8. You may not copy, modify, sublicense, link with, or distribute the
              Library except as expressly provided under this License. Any attempt
              otherwise to copy, modify, sublicense, link with, or distribute the Library
              is void, and will automatically terminate your rights under this License.
              However, parties who have received copies, or rights, from you under this
              License will not have their licenses terminated so long as such parties
              remain in full compliance.
            </p>
            <p>
              9. You are not required to accept this License, since you have not signed
              it. However, nothing else grants you permission to modify or distribute the
              Library or its derivative works. These actions are
            </p>
            <p>
              prohibited by law if you do not accept this License. Therefore, by
              modifying or distributing the Library (or any work based on the Library),
              you indicate your acceptance of this License to do so, and all its terms
              and conditions for copying, distributing or modifying the Library or works
              based on it.
            </p>
            <p>
              10. Each time you redistribute the Library (or any work based on the
              Library), the recipient automatically receives a license from the original
              licensor to copy, distribute, link with or modify the Library subject to
              these terms and conditions. You may not impose any further restrictions on
              the recipients' exercise of the rights granted herein. You are not
              responsible for enforcing compliance by third parties with this License.
            </p>
            <p>
              11. If, as a consequence of a court judgment or allegation of patent
              infringement or for any other reason (not limited to patent issues),
              conditions are imposed on you (whether by court order, agreement or
              otherwise) that contradict the conditions of this License, they do not
              excuse you from the conditions of this License. If you cannot distribute so
              as to satisfy simultaneously your obligations under this License and any
              other pertinent obligations, then as a consequence you may not distribute
              the Library at all. For example, if a patent license would not permit
              royalty-free redistribution of the Library by all those who receive copies
              directly or indirectly through you, then the only way you could satisfy
              both it and this License would be to refrain entirely from distribution of
              the Library.
            </p>
            <p>
              If any portion of this section is held invalid or unenforceable under any
              particular circumstance, the balance of the section is intended to apply,
              and the section as a whole is intended to apply in other circumstances.
            </p>
            <p>
              It is not the purpose of this section to induce you to infringe any patents
              or other property right claims or to contest validity of any such claims;
              this section has the sole purpose of protecting the integrity of the free
              software distribution system which is implemented by public license
              practices. Many people have made generous contributions to the wide range
              of software distributed through that system in reliance on consistent
              application of that system; it is up to the author/donor to decide if he or
              she is willing to distribute software through any other system and a
              licensee cannot impose that choice. This section is intended to make
              thoroughly clear what is believed to be a consequence of the rest of this
              License.
            </p>
            <p>
              12. If the distribution and/or use of the Library is restricted in certain
              countries either by patents or by copyrighted interfaces, the original
              copyright holder who places the Library under this License may add an
              explicit geographical distribution limitation excluding those countries, so
              that distribution is permitted only in or among countries not thus
              excluded. In such case, this License incorporates the limitation as if
              written in the body of this License.
            </p>
            <p>
              13. The Free Software Foundation may publish revised and/or new versions of
              the Lesser General Public License from time to time. Such new versions will
              be similar in spirit to the present version, but may differ in detail to
              address new problems or concerns.
            </p>
            <p>
              Each version is given a distinguishing version number. If the Library
              specifies a version number of this License which applies to it and "any
              later version", you have the option of following the terms and conditions
              either of that version or of any later version published by the Free
              Software Foundation. If the Library does not specify a license version
              number, you may choose any version ever published by
            </p>
            <p>the Free Software Foundation.</p>
            <p>
              14. If you wish to incorporate parts of the Library into other free
              programs whose distribution conditions are incompatible with these, write
              to the author to ask for permission. For software which is copyrighted by
              the Free Software Foundation, write to the Free Software Foundation; we
              sometimes make exceptions for this. Our decision will be guided by the two
              goals of preserving the free status
            </p>
            <p>
              of all derivatives of our free software and of promoting the sharing and
              reuse of software generally.
            </p>
            <p>NO WARRANTY</p>
            <p>
              15. BECAUSE THE LIBRARY IS LICENSED FREE OF CHARGE, THERE IS NO WARRANTY
              FOR THE LIBRARY, TO THE EXTENT PERMITTED BY APPLICABLE LAW. EXCEPT WHEN
              OTHERWISE STATED IN WRITING THE COPYRIGHT HOLDERS AND/OR OTHER PARTIES
              PROVIDE THE LIBRARY "AS IS" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED
              OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS FOR A PARTICULAR
            </p>
            <p>
              PURPOSE. THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THE LIBRARY
              IS WITH YOU. SHOULD THE LIBRARY PROVE DEFECTIVE, YOU ASSUME THE COST OF ALL
              NECESSARY SERVICING, REPAIR OR CORRECTION.
            </p>
            <p>
              16. IN NO EVENT UNLESS REQUIRED BY APPLICABLE LAW OR AGREED TO IN WRITING
              WILL ANY COPYRIGHT HOLDER, OR ANY OTHER PARTY WHO MAY MODIFY AND/OR
              REDISTRIBUTE THE LIBRARY AS PERMITTED ABOVE, BE LIABLE TO YOU FOR DAMAGES,
              INCLUDING ANY GENERAL, SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES ARISING
              OUT OF THE USE OR INABILITY TO USE THE LIBRARY (INCLUDING BUT NOT LIMITED
              TO LOSS OF DATA OR DATA BEING RENDERED INACCURATE OR LOSSES SUSTAINED BY
              YOU OR THIRD PARTIES OR A FAILURE OF THE LIBRARY TO OPERATE WITH ANY OTHER
              SOFTWARE), EVEN IF SUCH HOLDER OR OTHER PARTY HAS BEEN ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGES.
            </p>
            <p>END OF TERMS AND CONDITIONS</p>
            <p>How to Apply These Terms to Your New Libraries</p>
            <p>
              If you develop a new library, and you want it to be of the greatest
              possible use to the public, we recommend making it free software that
              everyone can redistribute and change. You can do so by permitting
              redistribution under these terms (or, alternatively, under the terms of the
              ordinary General Public License).
            </p>
            <p>
              To apply these terms, attach the following notices to the library. It is
              safest to attach them to the start of each source file to most effectively
              convey the exclusion of warranty; and each file should have at least the
              "copyright" line and a pointer to where the full notice is found.
            </p>
            <p>
              &lt;one line to give the library's name and a brief idea of what it
              does.&gt;
            </p>
            <p>Copyright (C) &lt;year&gt; &lt;name of author&gt;</p>
            <p>
              This library is free software; you can redistribute it and/or modify it
              under the terms of the GNU Lesser General Public License as published by
              the Free Software Foundation; either version 2.1 of the License, or (at
              your option) any later version. This library is distributed in the hope
              that it will be useful, but WITHOUT ANY WARRANTY; without even the implied
              warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
              GNU Lesser General Public License for more details.
            </p>
            <p>
              You should have received a copy of the GNU Lesser General Public License
              along with this library; if not, write to the Free Software Foundation,
              Inc., 59 Temple Place, Suite 330, Boston, MA 02111-1307 USA
            </p>
            <p>
              Also add information on how to contact you by electronic and paper mail.
              You should also get your employer (if you work as a programmer) or your
              school, if any, to sign a "copyright disclaimer" for the library, if
              necessary. Here is a sample; alter the names:
            </p>
            <p>
              Yoyodyne, Inc., hereby disclaims all copyright interest in the library
              `Frob' (a library for tweaking knobs) written by James Random Hacker.
            </p>
            <p>&lt;signature of Ty Coon&gt;, 1 April 1990</p>
            <p>Ty Coon, President of Vice</p>
            <p>That's all there is to it!</p>
            <p>
              <strong>MPL-2.0</strong>
            </p>
            <p>Mozilla Public License Version 2.0</p>
            <p>==================================</p>
            <p>1. Definitions</p>
            <p>--------------</p>
            <p>
              1.1. "Contributor" means each individual or legal entity that creates,
              contributes to the creation of, or owns Covered Software.
            </p>
            <p>
              1.2. "Contributor Version" means the combination of the Contributions of
              others (if any) used by a Contributor and that particular Contributor's
              Contribution.
            </p>
            <p>1.3. "Contribution" means Covered Software of a particular Contributor.</p>
            <p>
              1.4. "Covered Software" means Source Code Form to which the initial
              Contributor has attached the notice in Exhibit A, the Executable Form of
              such Source Code Form, and Modifications of such Source Code Form, in each
              case including portions thereof.
            </p>
            <p>1.5. "Incompatible With Secondary Licenses" means</p>
            <p>
              (a) that the initial Contributor has attached the notice described in
              Exhibit B to the Covered Software; or
            </p>
            <p>
              (b) that the Covered Software was made available under the terms of version
              1.1 or earlier of the License, but not also under the terms of a Secondary
              License.
            </p>
            <p>
              1.6. "Executable Form" means any form of the work other than Source Code
              Form.
            </p>
            <p>
              1.7. "Larger Work" means a work that combines Covered Software with other
              material, in a separate file or files, that is not Covered Software.
            </p>
            <p>1.8. "License" means this document.</p>
            <p>
              1.9. "Licensable" means having the right to grant, to the maximum extent
              possible, whether at the time of the initial grant or subsequently, any and
              all of the rights conveyed by this License.
            </p>
            <p>1.10. "Modifications" means any of the following:</p>
            <p>
              (a) any file in Source Code Form that results from an addition to, deletion
              from, or modification of the contents of Covered Software; or
            </p>
            <p>(b) any new file in Source Code Form that contains any Covered Software.</p>
            <p>
              1.11. "Patent Claims" of a Contributor means any patent claim(s), including
              without limitation, method, process, and apparatus claims, in any patent
              Licensable by such Contributor that would be infringed, but for the grant
              of the License, by the making, using, selling, offering for sale, having
              made, import, or transfer of either its Contributions or its Contributor
              Version.
            </p>
            <p>
              1.12. "Secondary License" means either the GNU General Public License,
              Version 2.0, the GNU Lesser General Public License, Version 2.1, the GNU
              Affero General Public License, Version 3.0, or any later versions of those
              licenses.
            </p>
            <p>
              1.13. "Source Code Form" means the form of the work preferred for making
              modifications.
            </p>
            <p>
              1.14. "You" (or "Your") means an individual or a legal entity exercising
              rights under this License. For legal entities, "You" includes any entity
              that controls, is controlled by, or is under common control with You. For
              purposes of this definition, "control" means (a) the power, direct or
              indirect, to cause the direction or management of such entity, whether by
              contract or otherwise, or (b) ownership of more than fifty percent (50%) of
              the outstanding shares or beneficial ownership of such entity.
            </p>
            <p>2. License Grants and Conditions</p>
            <p>--------------------------------</p>
            <p>2.1. Grants</p>
            <p>
              Each Contributor hereby grants You a world-wide, royalty-free,
              non-exclusive license:
            </p>
            <p>
              (a) under intellectual property rights (other than patent or trademark)
              Licensable by such Contributor to use, reproduce, make available, modify,
              display, perform, distribute, and otherwise exploit its Contributions,
              either on an unmodified basis, with Modifications, or as part of a Larger
              Work; and
            </p>
            <p>
              (b) under Patent Claims of such Contributor to make, use, sell, offer for
              sale, have made, import, and otherwise transfer either its Contributions or
              its Contributor Version.
            </p>
            <p>2.2. Effective Date</p>
            <p>
              The licenses granted in Section 2.1 with respect to any Contribution become
              effective for each Contribution on the date the Contributor first
              distributes such Contribution.
            </p>
            <p>2.3. Limitations on Grant Scope</p>
            <p>
              The licenses granted in this Section 2 are the only rights granted under
              this License. No additional rights or licenses will be implied from the
              distribution or licensing of Covered Software under this License.
              Notwithstanding Section 2.1(b) above, no patent license is granted by a
              Contributor:
            </p>
            <p>(a) for any code that a Contributor has removed from Covered Software; or</p>
            <p>
              (b) for infringements caused by: (i) Your and any other third party's
              modifications of Covered Software, or (ii) the combination of its
              Contributions with other software (except as part of its Contributor
              Version); or
            </p>
            <p>
              (c) under Patent Claims infringed by Covered Software in the absence of its
              Contributions.
            </p>
            <p>
              This License does not grant any rights in the trademarks, service marks, or
              logos of any Contributor (except as may be necessary to comply with the
              notice requirements in Section 3.4).
            </p>
            <p>2.4. Subsequent Licenses</p>
            <p>
              No Contributor makes additional grants as a result of Your choice to
              distribute the Covered Software under a subsequent version of this License
              (see Section 10.2) or under the terms of a Secondary License (if permitted
              under the terms of Section 3.3).
            </p>
            <p>2.5. Representation</p>
            <p>
              Each Contributor represents that the Contributor believes its Contributions
              are its original creation(s) or it has sufficient rights to grant the
              rights to its Contributions conveyed by this License.
            </p>
            <p>2.6. Fair Use</p>
            <p>
              This License is not intended to limit any rights You have under applicable
              copyright doctrines of fair use, fair dealing, or other equivalents.
            </p>
            <p>2.7. Conditions</p>
            <p>
              Sections 3.1, 3.2, 3.3, and 3.4 are conditions of the licenses granted in
              Section 2.1.
            </p>
            <p>3. Responsibilities</p>
            <p>-------------------</p>
            <p>3.1. Distribution of Source Form</p>
            <p>
              All distribution of Covered Software in Source Code Form, including any
              Modifications that You create or to which You contribute, must be under the
              terms of this License. You must inform recipients that the Source Code Form
              of the Covered Software is governed by the terms of this License, and how
              they can obtain a copy of this License. You may not attempt to alter or
              restrict the recipients' rights in the Source Code Form.
            </p>
            <p>3.2. Distribution of Executable Form</p>
            <p>If You distribute Covered Software in Executable Form then:</p>
            <p>
              (a) such Covered Software must also be made available in Source Code Form,
              as described in Section 3.1, and You must inform recipients of the
              Executable Form how they can obtain a copy of such Source Code Form by
              reasonable means in a timely manner, at a charge no more than the cost of
              distribution to the recipient; and
            </p>
            <p>
              (b) You may distribute such Executable Form under the terms of this
              License, or sublicense it under different terms, provided that the license
              for the Executable Form does not attempt to limit or alter the recipients'
              rights in the Source Code Form under this License.
            </p>
            <p>3.3. Distribution of a Larger Work</p>
            <p>
              You may create and distribute a Larger Work under terms of Your choice,
              provided that You also comply with the requirements of this License for the
              Covered Software. If the Larger Work is a combination of Covered Software
              with a work governed by one or more Secondary Licenses, and the Covered
              Software is not Incompatible With Secondary Licenses, this License permits
              You to additionally distribute such Covered Software under the terms of
              such Secondary License(s), so that the recipient of the Larger Work may, at
              their option, further distribute the Covered Software under the terms of
              either this License or such Secondary License(s).
            </p>
            <p>3.4. Notices</p>
            <p>
              You may not remove or alter the substance of any license notices (including
              copyright notices, patent notices, disclaimers of warranty, or limitations
              of liability) contained within the Source Code Form of the Covered
              Software, except that You may alter any license notices to the extent
              required to remedy known factual inaccuracies.
            </p>
            <p>3.5. Application of Additional Terms</p>
            <p>
              You may choose to offer, and to charge a fee for, warranty, support,
              indemnity or liability obligations to one or more recipients of Covered
              Software. However, You may do so only on Your own behalf, and not on behalf
              of any Contributor. You must make it absolutely clear that any such
              warranty, support, indemnity, or liability obligation is offered by You
              alone, and You hereby agree to indemnify every Contributor for any
              liability incurred by such Contributor as a result of warranty, support,
              indemnity or liability terms You offer. You may include additional
              disclaimers of warranty and limitations of liability specific to any
              jurisdiction.
            </p>
            <p>4. Inability to Comply Due to Statute or Regulation</p>
            <p>---------------------------------------------------</p>
            <p>
              If it is impossible for You to comply with any of the terms of this License
              with respect to some or all of the Covered Software due to statute,
              judicial order, or regulation then You must: (a) comply with the terms of
              this License to the maximum extent possible; and (b) describe the
              limitations and the code they affect. Such description must be placed in a
              text file included with all distributions of the Covered Software under
              this License. Except to the extent prohibited by statute or regulation,
              such description must be sufficiently detailed for a recipient of ordinary
              skill to be able to understand it.
            </p>
            <p>5. Termination</p>
            <p>--------------</p>
            <p>
              5.1. The rights granted under this License will terminate automatically if
              You fail to comply with any of its terms. However, if You become compliant,
              then the rights granted under this License from a particular Contributor
              are reinstated (a) provisionally, unless and until such Contributor
              explicitly and finally terminates Your grants, and (b) on an ongoing basis,
              if such Contributor fails to notify You of the non-compliance by some
              reasonable means prior to 60 days after You have come back into compliance.
              Moreover, Your grants from a particular Contributor are reinstated on an
              ongoing basis if such Contributor notifies You of the non-compliance by
              some reasonable means, this is the first time You have received notice of
              non-compliance with this License from such Contributor, and You become
              compliant prior to 30 days after Your receipt of the notice.
            </p>
            <p>
              5.2. If You initiate litigation against any entity by asserting a patent
              infringement claim (excluding declaratory judgment actions, counter-claims,
              and cross-claims) alleging that a Contributor Version directly or
              indirectly infringes any patent, then the rights granted to You by any and
              all Contributors for the Covered Software under Section 2.1 of this License
              shall terminate.
            </p>
            <p>
              5.3. In the event of termination under Sections 5.1 or 5.2 above, all end
              user license agreements (excluding distributors and resellers) which have
              been validly granted by You or Your distributors under this License prior
              to termination shall survive termination.
            </p>
            <p>6. Disclaimer of Warranty</p>
            <p>-------------------------</p>
            <p>
              COVERED SOFTWARE IS PROVIDED UNDER THIS LICENSE ON AN "AS IS" BASIS,
              WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED, IMPLIED, OR STATUTORY,
              INCLUDING, WITHOUT LIMITATION, WARRANTIES THAT THE COVERED SOFTWARE IS FREE
              OF DEFECTS, MERCHANTABLE, FIT FOR A PARTICULAR PURPOSE OR NON-INFRINGING.
              THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THE COVERED SOFTWARE
              IS WITH YOU. SHOULD ANY COVERED SOFTWARE PROVE DEFECTIVE IN ANY RESPECT,
              YOU (NOT ANY CONTRIBUTOR) ASSUME THE COST OF ANY NECESSARY SERVICING,
              REPAIR, OR CORRECTION. THIS DISCLAIMER OF WARRANTY CONSTITUTES AN ESSENTIAL
              PART OF THIS LICENSE. NO USE OF ANY COVERED SOFTWARE IS AUTHORIZED UNDER
              THIS LICENSE EXCEPT UNDER THIS DISCLAIMER.
            </p>
            <p>7. Limitation of Liability</p>
            <p>--------------------------</p>
            <p>
              UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY, WHETHER TORT (INCLUDING
              NEGLIGENCE), CONTRACT, OR OTHERWISE, SHALL ANY CONNTRIBUTOR, OR ANYONE WHO
              DISTRIBUTES COVERED SOFTWARE AS PERMITTED ABOVE, BE LIABLE TO YOU FOR ANY
              DIRECT, INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF ANY
              CHARACTER INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOST PROFITS, LOSS OF
              GOODWILL, WORK STOPPAGE, COMPUTER FAILURE OR MALFUNCTION, OR ANY AND ALL
              OTHER COMMERCIAL DAMAGES OR LOSSES, EVEN IF SUCH PARTY SHALL HAVE BEEN
              INFORMED OF THE POSSIBILITY OF SUCH DAMAGES. THIS LIMITATION OF LIABILITY
              SHALL NOT APPLY TO LIABILITY FOR DEATH OR PERSONAL INJURY RESULTING FROM
              SUCH PARTY'S NEGLIGENCE TO THE EXTENT APPLICABLE LAW PROHIBITS SUCH
              LIMITATION. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
              INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THIS EXCLUSION AND LIMITATION MAY
              NOT APPLY TO YOU. 8. Litigation
            </p>
            <p>-------------</p>
            <p>
              Any litigation relating to this License may be brought only in the courts
              of a jurisdiction where the defendant maintains its principal place of
              business and such litigation shall be governed by laws of that
              jurisdiction, without reference to its conflict-of-law provisions. Nothing
              in this Section shall prevent a party's ability to bring cross-claims or
              counter-claims.
            </p>
            <p>9. Miscellaneous</p>
            <p>----------------</p>
            <p>
              This License represents the complete agreement concerning the subject
              matter hereof. If any provision of this License is held to be
              unenforceable, such provision shall be reformed only to the extent
              necessary to make it enforceable. Any law or regulation which provides that
              the language of a contract shall be construed against the drafter shall not
              be used to construe this License against a Contributor.
            </p>
            <p>10. Versions of the License</p>
            <p>---------------------------</p>
            <p>10.1. New Versions</p>
            <p>
              Mozilla Foundation is the license steward. Except as provided in Section
              10.3, no one other than the license steward has the right to modify or
              publish new versions of this License. Each version will be given a
              distinguishing version number.
            </p>
            <p>10.2. Effect of New Versions</p>
            <p>
              You may distribute the Covered Software under the terms of the version of
              the License under which You originally received the Covered Software, or
              under the terms of any subsequent version published by the license steward.
            </p>
            <p>10.3. Modified Versions</p>
            <p>
              If you create software not governed by this License, and you want to create
              a new license for such software, you may create and use a modified version
              of this License if you rename the license and remove any references to the
              name of the license steward (except to note that such modified license
              differs from this License).
            </p>
            <p>10.4. Distributing Source Code Form that is Incompatible With Secondary</p>
            <p>Licenses</p>
            <p>
              If You choose to distribute Source Code Form that is Incompatible With
              Secondary Licenses under the terms of this version of the License, the
              notice described in Exhibit B of this License must be attached.
            </p>
            <p>Exhibit A - Source Code Form License Notice</p>
            <p>-------------------------------------------</p>
            <p>
              This Source Code Form is subject to the terms of the Mozilla Public
              License, v. 2.0. If a copy of the MPL was not distributed with this file,
              You can obtain one at http://mozilla.org/MPL/2.0/.
            </p>
            <p>
              If it is not possible or desirable to put the notice in a particular file,
              then You may include the notice in a location (such as a LICENSE file in a
              relevant directory) where a recipient would be likely to look for such a
              notice.
            </p>
            <p>You may add additional accurate notices of copyright ownership.</p>
            <p>Exhibit B - "Incompatible With Secondary Licenses" Notice</p>
            <p>---------------------------------------------------------</p>
            <p>
              This Source Code Form is "Incompatible With Secondary Licenses", as defined
              by the Mozilla Public License, v. 2.0.
            </p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageMixin from '../shared/pageMixin';

export default {
  mixins: [PageMixin],
  data() {
    return {
      pageName: '3rd Party Language (iOS)',
    };
  },
};
</script>



// WEBPACK FOOTER //
// app/src/pages/IOSThirdParty.vue